webpackJsonp([4],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(849),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        cropUsername: function cropUsername(uname) {
            if (uname) {
                return uname.length > 20 ? uname.substring(0, 20) + "..." : uname;
            } else {
                return "";
            }
        }
    }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      filterLocation: "Worldwide",
      filterViewType: "Everything is better ",
      tab: "all",
      spotTypes: ["all"],
      location: "worldwide",
      openLocations: false,
      selectorSpotTypes: [{
        label: "Hotels & Apartments",
        id: "hotel",
        search: ["hotel", "appartments"]
      }, {
        label: "Bars & Restaurants",
        id: "bar",
        search: ["bars", "restaurant", "reataurants", "bar"]
      }, {
        label: "Panoramic spots",
        id: "panaromic",
        search: ["all"]
      }],
      filterObject: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var linkQuery = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
    this.tab = linkQuery.tab ? linkQuery.tab : "all";
    if (this.tab && this.tab !== "all") {
      var obj = this.selectorSpotTypes.find(function (x, index) {
        if (x.id === _this.tab) {
          x["index"] = index;
          return x;
        }
      });
      // this.changespotType(obj.id, obj.search, obj.index);
    }
    this.location = linkQuery.loc ? linkQuery.loc : "Worldwide";
    this.filterLocation = linkQuery.loc ? linkQuery.loc : "worldwide";
    this.spotTypes = linkQuery.st ? linkQuery.st : "all";
  },

  methods: {
    changespotType: function changespotType(optionId, spotType, index) {
      this.tab = optionId;
      if (optionId === "all") {
        this.spotTypes = spotType;
        this.searchFilter();
      } else {
        if (index > 0) {
          var currentOption = this.selectorSpotTypes[index];
          this.selectorSpotTypes.splice(index, 1);
          this.selectorSpotTypes.unshift(currentOption);
        }
        this.spotTypes = spotType;
        this.searchFilter();
      }
    },
    searchFilter: function searchFilter() {
      localStorage.removeItem("homePageImages");
      var obj = {
        st: this.spotTypes,
        loc: this.location,
        filter: true,
        tab: this.tab
      };
      var filterObject = {
        filtered: true,
        st: this.spotTypes,
        loc: this.location,
        tab: this.tab
      };
      localStorage.setItem("filterSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterObject));
      this.$router.push({ path: "/", query: obj });
    },
    clearFilter: function clearFilter() {
      localStorage.removeItem("homePageImages");
      this.tab = "all";
      this.spotTypes = ["all"];
      this.location = "worldwide";
      var obj = {
        st: ["all"],
        loc: "worldwide",
        filter: true,
        tab: "all"
      };
      var filterObject = {
        filtered: false,
        st: ["all"],
        loc: "worldwide",
        tab: this.tab
      };
      localStorage.setItem("filterSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterObject));
      this.$router.push({ path: "/", query: obj });
    },
    setLocation: function setLocation(location) {
      this.filterLocation = location;
      this.location = location;
      this.openLocations = false;
      this.searchFilter();
    },
    toggleLocations: function toggleLocations() {
      this.openLocations = !this.openLocations;
    }
  }
});

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".search-container[data-v-1b0aece8]{color:#fff;width:90vw;font-family:MontSerrat-Regular;font-size:12px}@media screen and (min-width:769px){.search-container[data-v-1b0aece8]{width:100%;font-size:16px}}.search-container .search-overview[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.search-container .search-overview .what-with-a-view[data-v-1b0aece8]{font-weight:700;text-transform:capitalize}.search-container .search-overview .view-type-list[data-v-1b0aece8]{padding-left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:scroll;-ms-overflow-style:none;scrollbar-width:none}.search-container .search-overview .view-type-list .view-type-list-item[data-v-1b0aece8]{padding-left:10px;padding-right:10px;cursor:pointer;font-weight:100;white-space:nowrap}.search-container .search-overview .view-type-list .all[data-v-1b0aece8]{border-right:.5px solid hsla(0,0%,100%,.5)}.search-container .search-overview .view-type-list .active[data-v-1b0aece8]{font-family:MontSerrat;border-bottom:.5px solid #f5a623;font-weight:900}.search-container .search-overview .view-type-list[data-v-1b0aece8]::-webkit-scrollbar{display:none}.search-container .search-overview .logo[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#bd10e0;font-weight:700}.search-container .search-details[data-v-1b0aece8]{padding-top:5px;cursor:pointer;position:relative}.search-container .search-details .filter-container[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:36px;padding:10px 0;border-radius:23px;background-color:#1f1f1f}.search-container .search-details .filter-container .filter-location[data-v-1b0aece8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-transform:capitalize}.search-container .search-details .filter-container .filter-location .location-name[data-v-1b0aece8]{text-align:start;color:#b9b9b9;width:50%}.search-container .search-details .filter-container .filter-icon-select-dates[data-v-1b0aece8]{-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;white-space:nowrap}.search-container .search-details .filter-container .filter-icon-select-dates .separator[data-v-1b0aece8]{border-left:.5px solid #b9b9b9}.search-container .search-details .filter-container .filter-icon-select-dates .filter-icon[data-v-1b0aece8]{color:#b9b9b9}.btn-style[data-v-1b0aece8]{padding:6px 12px;border-radius:6px}.cancel-btn[data-v-1b0aece8]{background-color:#000;color:#fff;width:38%}.update-btn[data-v-1b0aece8]{width:70%;background-color:#f5a623;color:#000}.location-dropdown[data-v-1b0aece8]{background-color:#000;color:#fff;border-radius:20px;position:absolute;font-family:MontSerrat-Regular;padding:6px;width:100%;top:36px;left:0;text-align:left;height:200px}.location-dropdown .location-list[data-v-1b0aece8]{padding:4px 35px}@media only screen and (min-width:768px){.location-dropdown[data-v-1b0aece8]{padding:5px}.location-dropdown .location-list[data-v-1b0aece8]{padding:5px 40px}}.location-dropdown li[data-v-1b0aece8]{margin:6px 0;font-weight:700}.location-dropdown .location-name[data-v-1b0aece8]{text-transform:capitalize;font-family:MontSerrat;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.location-dropdown ul[data-v-1b0aece8]{height:100%}.dates-dropdown[data-v-1b0aece8]{color:#fff;margin:5px 0;border-top:.5px solid #b9b9b9;border-bottom:.5px solid #b9b9b9;padding:0 12px;border-radius:6px;max-height:376px;overflow:auto;width:100%;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex}.dates-dropdown .check-in-date[data-v-1b0aece8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:6px 0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;border-right:1px solid #b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.dates-dropdown .check-in-date label[data-v-1b0aece8]{margin-left:5px}.dates-dropdown .check-out-date[data-v-1b0aece8]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:6px 0;display:-webkit-box;display:-ms-flexbox;display:flex;color:#b9b9b9;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:10px}.dates-dropdown .check-out-date label[data-v-1b0aece8]{margin-left:5px}.no-of-guests[data-v-1b0aece8]{margin-top:2px;width:100%}.set-button[data-v-1b0aece8]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:10px;background-color:transparent;font-family:MontSerrat-Regular;font-weight:100;padding:5px 10px;border:1px solid #b9b9b9;color:#b9b9b9}.set-button[data-v-1b0aece8]:hover{font-weight:800;color:#fff}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/common/searchContainer.vue"],"names":[],"mappings":"AACA,mCACE,WAAe,AACf,WAAY,AACZ,+BAAkC,AAClC,cAAgB,CACjB,AACD,oCACA,mCACM,WAAY,AACZ,cAAgB,CACrB,CACA,AACD,oDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,sEACM,gBAAkB,AAClB,yBAA2B,CAChC,AACD,oEACM,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,wBAAyB,AAEzB,oBAAsB,CAE3B,AACD,yFACQ,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CAC3B,AACD,yEACQ,0CAAmD,CAC1D,AACD,4EACQ,uBAA0B,AAC1B,iCAAmC,AACnC,eAAiB,CACxB,AACD,uFACM,YAAc,CACnB,AACD,0DACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,cAAe,AACf,eAAkB,CACvB,AACD,mDACI,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACtB,AACD,qEACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,eAAkB,AAClB,mBAAoB,AACpB,wBAA0B,CAC/B,AACD,sFACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA2B,CAClC,AACD,qGACU,iBAAkB,AAClB,cAAe,AACf,SAAW,CACpB,AACD,+FACQ,oBAAqB,AACjB,cAAe,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,kBAAoB,CAC3B,AACD,0GACU,8BAAiC,CAC1C,AACD,4GACU,aAAe,CACxB,AACD,4BACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,6BACE,sBAA0B,AAC1B,WAAe,AACf,SAAW,CACZ,AACD,6BACE,UAAW,AACX,yBAA0B,AAC1B,UAAe,CAChB,AACD,oCACE,sBAA0B,AAC1B,WAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,+BAAkC,AAClC,YAAa,AACb,WAAY,AACZ,SAAU,AACV,OAAU,AACV,gBAAiB,AACjB,YAAc,CACf,AACD,mDACI,gBAAkB,CACrB,AACD,yCACA,oCACM,WAAa,CAClB,AACD,mDACQ,gBAAkB,CACzB,CACA,AACD,uCACI,aAAc,AACd,eAAiB,CACpB,AACD,mDACI,0BAA2B,AAC3B,uBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,uCACI,WAAa,CAChB,AACD,iCACE,WAAe,AACf,aAAgB,AAChB,8BAAgC,AAChC,iCAAmC,AACnC,eAAkB,AAClB,kBAAmB,AACnB,iBAAkB,AAClB,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,gDACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,+BAAgC,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,sDACM,eAAiB,CACtB,AACD,iDACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAe,AACf,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,CACrB,AACD,uDACM,eAAiB,CACtB,AACD,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,6BACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAiB,AACjB,6BAA8B,AAC9B,+BAAkC,AAClC,gBAAiB,AACjB,iBAAkB,AAClB,yBAA0B,AAC1B,aAAe,CAChB,AACD,mCACI,gBAAiB,AACjB,UAAe,CAClB","file":"searchContainer.vue","sourcesContent":["\n.search-container[data-v-1b0aece8] {\n  color: #ffffff;\n  width: 90vw;\n  font-family: \"MontSerrat-Regular\";\n  font-size: 12px;\n}\n@media screen and (min-width: 769px) {\n.search-container[data-v-1b0aece8] {\n      width: 100%;\n      font-size: 16px;\n}\n}\n.search-container .search-overview[data-v-1b0aece8] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.search-container .search-overview .what-with-a-view[data-v-1b0aece8] {\n      font-weight: bold;\n      text-transform: capitalize;\n}\n.search-container .search-overview .view-type-list[data-v-1b0aece8] {\n      padding-left: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      overflow: scroll;\n      -ms-overflow-style: none;\n      /* IE and Edge */\n      scrollbar-width: none;\n      /* Firefox */\n}\n.search-container .search-overview .view-type-list .view-type-list-item[data-v-1b0aece8] {\n        padding-left: 10px;\n        padding-right: 10px;\n        cursor: pointer;\n        font-weight: 100;\n        white-space: nowrap;\n}\n.search-container .search-overview .view-type-list .all[data-v-1b0aece8] {\n        border-right: 0.5px solid rgba(255, 255, 255, 0.5);\n}\n.search-container .search-overview .view-type-list .active[data-v-1b0aece8] {\n        font-family: \"MontSerrat\";\n        border-bottom: 0.5px solid #f5a623;\n        font-weight: 900;\n}\n.search-container .search-overview .view-type-list[data-v-1b0aece8]::-webkit-scrollbar {\n      display: none;\n}\n.search-container .search-overview .logo[data-v-1b0aece8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n      color: #bd10e0;\n      font-weight: bold;\n}\n.search-container .search-details[data-v-1b0aece8] {\n    padding-top: 5px;\n    cursor: pointer;\n    position: relative;\n}\n.search-container .search-details .filter-container[data-v-1b0aece8] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      min-height: 36px;\n      padding: 10px 0px;\n      border-radius: 23px;\n      background-color: #1f1f1f;\n}\n.search-container .search-details .filter-container .filter-location[data-v-1b0aece8] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        text-transform: capitalize;\n}\n.search-container .search-details .filter-container .filter-location .location-name[data-v-1b0aece8] {\n          text-align: start;\n          color: #b9b9b9;\n          width: 50%;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates[data-v-1b0aece8] {\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        color: #b9b9b9;\n        white-space: nowrap;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates .separator[data-v-1b0aece8] {\n          border-left: 0.5px solid #b9b9b9;\n}\n.search-container .search-details .filter-container .filter-icon-select-dates .filter-icon[data-v-1b0aece8] {\n          color: #b9b9b9;\n}\n.btn-style[data-v-1b0aece8] {\n  padding: 6px 12px;\n  border-radius: 6px;\n}\n.cancel-btn[data-v-1b0aece8] {\n  background-color: #000000;\n  color: #ffffff;\n  width: 38%;\n}\n.update-btn[data-v-1b0aece8] {\n  width: 70%;\n  background-color: #f5a623;\n  color: #000000;\n}\n.location-dropdown[data-v-1b0aece8] {\n  background-color: #000000;\n  color: #ffffff;\n  border-radius: 20px;\n  position: absolute;\n  font-family: \"MontSerrat-Regular\";\n  padding: 6px;\n  width: 100%;\n  top: 36px;\n  left: 0px;\n  text-align: left;\n  height: 200px;\n}\n.location-dropdown .location-list[data-v-1b0aece8] {\n    padding: 4px 35px;\n}\n@media only screen and (min-width: 768px) {\n.location-dropdown[data-v-1b0aece8] {\n      padding: 5px;\n}\n.location-dropdown .location-list[data-v-1b0aece8] {\n        padding: 5px 40px;\n}\n}\n.location-dropdown li[data-v-1b0aece8] {\n    margin: 6px 0;\n    font-weight: 700;\n}\n.location-dropdown .location-name[data-v-1b0aece8] {\n    text-transform: capitalize;\n    font-family: \"MontSerrat\";\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.location-dropdown ul[data-v-1b0aece8] {\n    height: 100%;\n}\n.dates-dropdown[data-v-1b0aece8] {\n  color: #ffffff;\n  margin: 5px 0px;\n  border-top: 0.5px solid #b9b9b9;\n  border-bottom: 0.5px solid #b9b9b9;\n  padding: 0px 12px;\n  border-radius: 6px;\n  max-height: 376px;\n  overflow: auto;\n  width: 100%;\n  text-align: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.dates-dropdown .check-in-date[data-v-1b0aece8] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    padding: 6px 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #b9b9b9;\n    border-right: 1px solid #b9b9b9;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.dates-dropdown .check-in-date label[data-v-1b0aece8] {\n      margin-left: 5px;\n}\n.dates-dropdown .check-out-date[data-v-1b0aece8] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    padding: 6px 0px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #b9b9b9;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 10px;\n}\n.dates-dropdown .check-out-date label[data-v-1b0aece8] {\n      margin-left: 5px;\n}\n.no-of-guests[data-v-1b0aece8] {\n  margin-top: 2px;\n  width: 100%;\n}\n.set-button[data-v-1b0aece8] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 10px;\n  background-color: transparent;\n  font-family: \"MontSerrat-Regular\";\n  font-weight: 100;\n  padding: 5px 10px;\n  border: 1px solid #b9b9b9;\n  color: #b9b9b9;\n}\n.set-button[data-v-1b0aece8]:hover {\n    font-weight: 800;\n    color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("07a36066", content, true, {});

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjI2IiBoZWlnaHQ9IjEyOCIgdmVyc2lvbj0iMS4xIiBzdHlsZT0iIj48cmVjdCBpZD0iYmFja2dyb3VuZHJlY3QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9IjAiIHk9IjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMSI+CiAgPHBhdGggZD0iTSA3NSAwIEwgMTU3IDEyOCBMIDE3NiAxMjggTCAxMzUgNjQgTCAxNTcgMzAgTCAyMjYgMTI4IEwgMCAxMjggWiBNIDc1IDAgIiBpZD0ic3ZnXzEiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgoKPGcgY2xhc3M9ImN1cnJlbnRMYXllciIgc3R5bGU9IiI+PHRpdGxlPkxheWVyIDE8L3RpdGxlPjxnIGlkPSJzdXJmYWNlMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsPSIjMDAwMDAwIiBmaWxsLW9wYWNpdHk9IjEiPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDEpIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGlkPSJzdmdfMiIgZmlsbD0iIzAwMDAwMCIgZmlsbC1vcGFjaXR5PSIxIj4KPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjIyNiIgaGVpZ2h0PSIxMjgiIHN0eWxlPSJzdHJva2U6IG5vbmU7IiBpZD0ic3ZnXzMiIGZpbGw9IiMwMDAwMDAiIGZpbGwtb3BhY2l0eT0iMSIvPgo8L2c+CjwvZz48L2c+PC9zdmc+"

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b0aece8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-overview"
  }, [_c('ul', {
    staticClass: "view-type-list"
  }, [_c('li', {
    staticClass: "view-type-list-item pl-0 all",
    attrs: {
      "id": "all"
    },
    on: {
      "click": function($event) {
        return _vm.changespotType('all', ['all'], null)
      }
    }
  }, [_c('span', {
    class: _vm.tab === 'all' ? 'active' : ''
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.selectorSpotTypes), function(optionItem, index) {
    return _c('li', {
      key: index,
      staticClass: "view-type-list-item",
      attrs: {
        "id": optionItem.id
      },
      on: {
        "click": function($event) {
          return _vm.changespotType(optionItem.id, optionItem.search, index)
        }
      }
    }, [_c('span', {
      class: _vm.tab === ("" + (optionItem.id)) ? 'active' : ''
    }, [_vm._v(_vm._s(optionItem.label) + "\n            "), (_vm.tab === ("" + (optionItem.id))) ? _c('span', {
      staticClass: "hidden-sm-and-down"
    }, [_vm._v("with A view")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "search-details"
  }, [_c('div', {
    staticClass: "filter-container mt-1"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative",
      "padding": "0px 20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "filter-location"
  }, [_c('i', {
    staticClass: "material-icons cursor",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("arrow_back_ios")]), _vm._v(" "), _c('span', {
    staticClass: "location-name",
    on: {
      "click": _vm.toggleLocations
    }
  }, [_vm._v(_vm._s(_vm.filterLocation))])])]), _vm._v(" "), (_vm.openLocations) ? _c('div', {
    staticClass: "location-dropdown",
    on: {
      "mouseleave": _vm.toggleLocations
    }
  }, [_c('vue-scroll', [_c('ul', {
    staticClass: "location-list"
  }, [_c('li', {
    staticClass: "location-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.filterLocation))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "20px",
      "padding": "5px 5px 5px 15px"
    },
    on: {
      "click": _vm.toggleLocations
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#979797",
      "width": "100%",
      "height": "1px"
    }
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('worldwide')
      }
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('barcelona')
      }
    }
  }, [_vm._v("Barcelona")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('berlin')
      }
    }
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('copenhagen')
      }
    }
  }, [_vm._v("Copenhagen")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('florence')
      }
    }
  }, [_vm._v("Florence")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('lisbon')
      }
    }
  }, [_vm._v("Lisbon")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('london')
      }
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('los angeles')
      }
    }
  }, [_vm._v("Los Angeles")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('madrid')
      }
    }
  }, [_vm._v("Madrid")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('milan')
      }
    }
  }, [_vm._v("Milan")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('new york')
      }
    }
  }, [_vm._v("New York")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('paris')
      }
    }
  }, [_vm._v("Paris")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('porto')
      }
    }
  }, [_vm._v("Porto")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('rome')
      }
    }
  }, [_vm._v("Rome")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setLocation('san francisco')
      }
    }
  }, [_vm._v("San Francisco")])])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixin_imageLinks__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_cropUsername__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_gen__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_identifyOS__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixin_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_bottomNavigation_vue__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_bottomNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_common_bottomNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_homepage_searchModal_vue__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_homepage_searchModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_homepage_searchModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_searchContainer_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_searchContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_common_searchContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configurations__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configurations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__configurations__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






//






//
var vm = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { bottomNavigation: __WEBPACK_IMPORTED_MODULE_12__components_common_bottomNavigation_vue___default.a, searchModal: __WEBPACK_IMPORTED_MODULE_13__components_homepage_searchModal_vue___default.a, searchContainer: __WEBPACK_IMPORTED_MODULE_14__components_common_searchContainer_vue___default.a },
  metaInfo: function metaInfo() {
    return {
      title: "with a view"
    };
  },

  filters: {
    getName: function getName() {
      var str = vm === undefined ? "" : vm.selectedCity;
      if (str.length > 20) {
        var s = str.substring(0, 20);
        return s + "...";
      } else {
        return str;
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixin_share__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixin_imageLinks__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixin_cropUsername__["a" /* default */]],
  data: function data() {
    return {
      showNoMorePhotoSlackBar: true,
      windowInnerHeight: window.innerHeight,
      isSwipeZoom: false,
      appDelay: 0.1,
      appSwipeTime: 1,
      onBoardingData: [], //onBoarding,
      showOnboardings: false,
      currentOnBoardImageIndex: 0,
      delay: 0.1, // 0
      swipeTime: 1, // 0
      swipeArrowIcon: "fa-arrow-up",
      swipeArrowText: "",
      selectedCity: "Berlin",
      //
      isDeviceIOS: false,
      visitedIndexes: [0],
      currentPage: 0,
      showSwipeLoader: false,
      none: "prev",
      prevImgIndex: false,
      screenH: 0,
      showCarousel: true,
      isEventDoubleClick: false,
      changeAdmire: false,
      admireMode: true,
      screenW: 0,
      swipeIndex: 0,
      swipeCount: null,
      tapped: false,
      totalScrollImageHeight: 0,
      hideOnBoardingOn: [],
      isFirstTimeOn1: true,
      //
      os: null,
      desktop: null,
      browser: null,
      clickDelay: 600,
      clicks: 0,
      timer: null,
      showScrollArrow: true,
      scrollId: null,
      //
      filterLocation: "Anywhere",
      filterViewType: "Everything is better ",
      //
      currentDomain: __WEBPACK_IMPORTED_MODULE_15__configurations___default.a.currentDomain,
      searchModalOpen: false,
      tab: "",
      showNavbar: true,
      lastScrollPosition: 0,
      target: "_blank"
    };
  },

  //
  watch: {
    "$store.state.gen.finalUserLocation": function $storeStateGenFinalUserLocation() {
      vm.getLocation();
    },
    //
    "$route.query": function $routeQuery() {
      vm.$store.state.hello.filteredImagesArr = [];
      vm.totalScrollImageHeight = 0;
      var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
      vm.tab = obj.tab ? obj.tab : "all";
      console.log("ACTIVE TAB", vm.tab);
      if (localStorage.getItem("_p") !== null) {
        if (obj.loc.toLowerCase() === "worldwide") {
          vm.$store.commit("getElsewherePics", {
            limit: vm.limit,
            startAt: 0,
            emotionalAppeal: obj.emotionalAppeal === undefined ? ["all"] : obj.emotionalAppeal,
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : Array.isArray(obj.st) ? obj.st : [obj.st],
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit("getMainScreenImages", {
            query: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal: obj.emotionalAppeal === undefined ? ["all"] : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : Array.isArray(obj.st) ? obj.st : [obj.st],
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo
          });
        }
      }
      if (obj.filter) {
        if (obj.loc.toLowerCase() === "worldwide") {
          vm.$store.commit("getElsewherePics", {
            limit: vm.limit,
            startAt: 0,
            emotionalAppeal: obj.emotionalAppeal === undefined ? ["all"] : obj.emotionalAppeal,
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : obj.st,
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit("getMainScreenImages", {
            query: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal: obj.emotionalAppeal === undefined ? ["all"] : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : obj.st,
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo
          });
        }
      }
    },
    //
    "$store.state.common.isModeSwipe": function $storeStateCommonIsModeSwipe() {
      vm.totalScrollImageHeight = 0;
      localStorage.setItem("MODE", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$store.state.common.isModeSwipe));
      if (!vm.$store.state.common.isModeSwipe) {
        setTimeout(function () {
          document.getElementsByClassName("img-cont")[0].style.width = vm.screenW + "px";
        }, 200);
      }
    },
    swipeIndex: function swipeIndex() {
      var _this = this;

      //
      setTimeout(function () {
        if (_this.swipeIndex === 4) {
          _this.swipeArrowText = "";
          _this.swipeArrowIcon = "";
        } else if (_this.swipeIndex === 0) {
          _this.swipeArrowText = "";
          _this.swipeArrowIcon = "fa-arrow-up";
        }
      }, 1000);
      //
      if (this.visitedIndexes[this.visitedIndexes.length - 1] < this.swipeIndex) {
        this.visitedIndexes.push(this.swipeIndex);
        this.visitedIndexes.sort();
        if (this.swipeIndex === this.filteredImagesArr.length - 1 && localStorage.getItem("homePageImages") === null) {
          // console.log(
          //   "IN IF ie. => this.swipeIndex == (this.startAt + this.limit - 1) is true"
          // );
          // CALL API
          //
          var _obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
          if (this.$route.query.loc.toLowerCase() !== "worldwide") {
            this.$store.commit("getMainScreenImages", {
              query: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
              startAt: this.filteredImagesArr.length,
              limit: vm.limit,
              uid: vm.$store.state.auth.user.uid,
              isLoggedIn: vm.$store.state.auth.isLoggedIn,
              emotionalAppeal: _obj.emotionalAppeal === undefined ? ["all"] : [_obj.emotionalAppeal],
              keywords: _obj.keywords === undefined ? ["extabs"] : _obj.keywords,
              spotType: _obj.st === undefined ? ["all"] : _obj.st,
              viewType: _obj.vt === undefined ? ["all"] : _obj.vt,
              sortBy: _obj.srt,
              addressIndex: [_obj.loc],
              userGeo: _obj.userGeo
            });
          } else {
            vm.$store.commit("getElsewherePics", {
              limit: this.limit,
              startAt: this.filteredImagesArr.length,
              emotionalAppeal: _obj.emotionalAppeal === undefined ? ["all"] : [_obj.emotionalAppeal],
              keywords: _obj.keywords === undefined ? ["extabs"] : [_obj.keywords],
              spotType: _obj.st === undefined ? ["all"] : Array.isArray(_obj.st) ? _obj.st : [_obj.st],
              viewType: _obj.vt === undefined ? [] : [_obj.vt],
              sortBy: _obj.srt,
              userGeo: _obj.userGeo
            });
          }
        } else {
          localStorage.removeItem("homePageImages");
        }
      }
      //
      // CHECK TO REMOVE ON BOARDING...
      if (this.swipeIndex === 1) {
        if (this.isFirstTimeOn1) {
          // DO NOTHING
        } else {
          if (this.hideOnBoardingOn.indexOf(1) === -1) {
            this.hideOnBoardingOn.push(1);
          }
          this.$forceUpdate();
        }
        //
        this.isFirstTimeOn1 = false;
        if (this.hideOnBoardingOn.indexOf(0) === -1) {
          this.hideOnBoardingOn.push(0);
        }
      }
      //
    },
    //
    selectedCity: function selectedCity() {
      if (vm.selectedCity === undefined) {
        vm.$router.push({
          path: "/",
          query: {
            loc: "worldwide"
          }
        });
        vm.selectedCity = "worldwide";
      } else {
        var _obj2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, vm.$route.query);
        _obj2.loc = vm.selectedCity;
        vm.$router.push({
          path: "/",
          query: _obj2
        });
      }
    },
    currentOnBoardImageIndex: {
      handler: function handler() {
        var _this2 = this;

        if (this.currentOnBoardImageIndex === 5) {
          setTimeout(function () {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("berlin-viewzzz") != null) {
              document.getElementById("berlin-viewzzz").addEventListener("click", function () {
                _this2.incrementApp();
              });
              document.getElementById("berlin-viewzzz-2").addEventListener("click", function () {
                _this2.incrementApp();
              });
            }
          }, 40);
          //
        }
      }
    }
    //
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapMutations */])(["goToImageDetMap", "goTo_uploadImage", "fadeOpen", "getMainScreenImages", "operationOnPhoto", "getLocation", "snackbar_alert"]), {
    closeSearchModal: function closeSearchModal() {
      this.searchModalOpen = false;
    },
    openSearchModal: function openSearchModal() {
      this.searchModalOpen = true;
    },
    onScroll: function onScroll(pos) {
      if (pos > 500) {
        if (pos - this.lastScrollPosition < 0) {
          document.getElementById("sticky-search-bar").style.top = '0px';
        } else {
          document.getElementById("sticky-search-bar").style.top = '-100%';
        }
        this.lastScrollPosition = pos;
      } else {
        document.getElementById("sticky-search-bar").style.top = '0px';
      }
    },
    getImageClasses: function getImageClasses(imageIndex) {
      if (imageIndex == 0) {
        return "relative-img touch first-image";
      } else if (imageIndex == this.filteredImagesArr.length - 1) {
        return "relative-img touch last-image";
      } else {
        return "relative-img touch ";
      }
    },
    goToUpload: function goToUpload() {
      if (this.$store.state.auth.isLoggedIn) {
        this.$router.push("/upload-0");
      } else {
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg: "Please sign-in to complete this action. It takes only a few seconds."
        });
      }
    },
    saveMode: function saveMode() {
      localStorage.setItem("MODE", this.$store.state.common.isModeSwipe);
    },
    getScrollPos: function getScrollPos() {
      var elem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-scroll");
      var containerScrollPos = elem.scrollTop;
      this.onScroll(containerScrollPos);
      var containerScrollHeight = elem.scrollHeight;
      if (containerScrollPos >= containerScrollHeight - 1000 && !this.$store.state.hello.fetchingImagesFromDb && this.$store.state.hello.fetchedPicsLength > this.$store.state.hello.limit) {
        var _obj3 = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
        if (_obj3.srt) {
          if (_obj3.srt === "ts") {
            _obj3.srt = "createdAt";
          } else if (_obj3.srt === "lks") {
            _obj3.srt = "likes";
          } else if (_obj3.srt === "km") {
            _obj3.srt = "distance";
          } else {
            _obj3.srt = _obj3.srt;
          }
        }

        if (vm.$route.query.loc.toLowerCase() === "worldwide") {
          vm.$store.commit("getElsewherePics", {
            limit: vm.limit,
            startAt: this.filteredImagesArr.length,
            emotionalAppeal: _obj3.emotionalAppeal === undefined ? ["all"] : [_obj3.emotionalAppeal],
            keywords: _obj3.keywords === undefined ? ["extabs"] : [_obj3.keywords],
            spotType: _obj3.st === undefined ? ["all"] : Array.isArray(_obj3.st) ? _obj3.st : [_obj3.st],
            viewType: _obj3.vt === undefined ? ["all"] : [_obj3.vt],
            sortBy: _obj3.srt,
            userGeo: _obj3.userGeo
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit("getMainScreenImages", {
            query: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
            startAt: this.filteredImagesArr.length,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal: _obj3.emotionalAppeal === undefined ? ["all"] : [_obj3.emotionalAppeal],
            keywords: _obj3.keywords === undefined ? ["extabs"] : [_obj3.keywords],
            spotType: _obj3.st === undefined ? ["all"] : Array.isArray(_obj3.st) ? _obj3.st : [_obj3.st],
            sortBy: _obj3.srt,
            addressIndex: [vm.$route.query.loc],
            userGeo: _obj3.userGeo
          });
        }
      }
      if (containerScrollPos > 4 * screen.height) {
        this.showScrollArrow = false;
      }
    },


    // ONBOARDINGS
    decrementApp: function decrementApp() {
      var _this3 = this;

      if (vm.currentOnBoardImageIndex !== 0) {
        this.none = "prev";
        var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe-app").scrollLeft;
        var elemB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-black-" + vm.currentOnBoardImageIndex + "-app");
        var elemI = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-image-" + vm.currentOnBoardImageIndex + "-app");
        elemI.style.backgroundImage = "url(" + vm.onBoardingData[vm.currentOnBoardImageIndex].image + ")";
        elemI.style.backgroundSize = "cover";
        elemI.style.backgroundSize = "auto " + vm.screenH + "px";
        elemI.style.backgroundPositionX = "-" + pos + "px";
        elemI.style.backgroundRepeat = "no-repeat";
        setTimeout(function () {
          _this3.currentPage = vm.currentOnBoardImageIndex;
          elemB.style.visibility = "visible";
          elemI.style.visibility = "visible";
          TweenMax.from(elemB, vm.delay, {
            opacity: 0,
            onComplete: function onComplete() {
              vm.showSwipeLoader = true;
              if (vm.currentOnBoardImageIndex === 0) {} else {
                vm.currentOnBoardImageIndex--;
              }
              elemB.style.opacity = 0.99;
              TweenMax.from(elemB, vm.swipeTime, {
                bottom: 0,
                delay: vm.delay,
                opacity: 0.6
              });
              TweenMax.from(".current-page", vm.delay, { y: -420, opacity: 0 });
              TweenMax.from(elemI, vm.swipeTime, {
                bottom: 0,
                delay: vm.delay,
                onComplete: function onComplete() {
                  elemB.style.visibility = "hidden";
                  elemI.style.visibility = "hidden";
                }
              });
            }
          });
        }, 10);
      }
    },
    incrementApp: function incrementApp() {
      var _this4 = this;

      if (vm.currentOnBoardImageIndex < 6) {
        this.none = "next";
        var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe-app").scrollLeft;
        var elemBN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-black-inc-" + vm.currentOnBoardImageIndex + "-app");
        var elemIN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-image-inc-" + vm.currentOnBoardImageIndex + "-app");
        elemIN.style.backgroundImage = "url(" + vm.onBoardingData[vm.currentOnBoardImageIndex].image + ")";
        elemIN.style.backgroundSize = "cover";
        elemIN.style.minWidth = vm.screenW + "px";
        elemIN.style.backgroundSize = "auto " + vm.screenH + "px";
        elemIN.style.backgroundSize = "auto " + vm.screenH + "px";
        elemIN.style.backgroundPositionX = "-" + pos + "px";
        elemIN.style.backgroundRepeat = "no-repeat";
        setTimeout(function () {
          _this4.currentPage = vm.currentOnBoardImageIndex + 1;
          elemBN.style.visibility = "visible";
          elemIN.style.visibility = "visible";
          TweenMax.from(elemBN, vm.delay, {
            opacity: 0,
            onComplete: function onComplete() {
              vm.showSwipeLoader = true;
              if (vm.currentOnBoardImageIndex === 5) {
                vm.showOnboardings = false;
              } else {
                vm.currentOnBoardImageIndex++;
              }
              elemBN.style.opacity = 0.99;
              TweenMax.from(elemBN, vm.swipeTime, {
                top: 0,
                delay: vm.delay,
                opacity: 0.6
              });
              TweenMax.from(".current-page", vm.delay, {
                y: 420,
                opacity: 0.6
              });
              TweenMax.from(elemIN, vm.swipeTime, {
                top: 0,
                delay: vm.delay,
                onComplete: function onComplete() {
                  elemBN.style.visibility = "hidden";
                  elemIN.style.visibility = "hidden";
                }
              });
            }
          });
        }, 10);
      }
    },
    recenterImageApp: function recenterImageApp() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe-app").scrollLeft = 0;
      this.easeOutApp(100);
    },
    easeOutApp: function easeOutApp(time) {
      setTimeout(function () {
        var currentScrollPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe-app").scrollLeft;
        var upperLimit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("element-" + vm.currentOnBoardImageIndex + "-app").clientWidth - vm.screenW;
        var lowerLimit = 0;
        var scrollWidth = upperLimit / 2;
        if (currentScrollPosition >= upperLimit - 10 || currentScrollPosition <= lowerLimit + 10) {
          TweenMax.to("#layout-swipe-app", 1, {
            scrollLeft: scrollWidth,
            ease: Bounce.easeOut
          });
        }
      }, time);
    },
    imageDet: function imageDet(image, index) {
      if (event.ctrlKey) {
        localStorage.setItem("scrollId", "scroll" + index);
        this.saveInLs();
      } else {
        localStorage.setItem("scrollId", "scroll" + index);
        this.$router.push({
          path: "/id/" + image.id + "?inapp=true"
        });
        this.saveInLs();
      }
    },
    imageClick: function imageClick(event, image) {
      this.clicks++;
      var self = this;
      if (self.clicks === 1) {
        self.timer = setTimeout(function () {
          self.imageDet(image);
          self.clicks = 0;
        }, self.clickDelay);
      } else {
        clearTimeout(this.timer);
        self.changeCnt();
        self.clicks = 0;
      }
    },
    changeMode: function changeMode() {
      var _this5 = this;

      setTimeout(function () {
        if (_this5.screenW < 600) {
          _this5.$store.state.common.isModeSwipe = true;
        } else {
          _this5.getScroll(0);
        }
      }, 300);
    },
    setSwipeIndex: function setSwipeIndex() {
      this.swipeIndex = 0;
    },
    noMorePhotos: function noMorePhotos() {
      if (!this.morePhotos && this.swipeIndex == this.maxPhotos - 1 && this.showNoMorePhotoSlackBar) {
        this.showNoMorePhotoSlackBar = false;
        this.$store.commit("snackbar_alert", {
          msg: "No more spots..."
        });
      }
    },
    recenterImage: function recenterImage() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe").scrollLeft = 0;
      this.easeOut(100);
    },
    increment: function increment() {
      var _this6 = this;

      if (!this.isSwipeZoom) {
        if (vm.swipeIndex != vm.maxPhotos - 1) {
          this.none = "next";
          var elemBN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-black-inc-" + vm.swipeIndex);
          var elemIN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-image-inc-" + vm.swipeIndex);
          elemIN.style.backgroundImage = "url(" + vm.fullscreenImage(vm.filteredImagesArr[vm.swipeIndex].id, vm.filteredImagesArr[vm.swipeIndex]) + ")";
          elemIN.style.backgroundSize = "cover";
          elemIN.style.minWidth = vm.screenW + "px";
          setTimeout(function () {
            _this6.currentPage = vm.swipeIndex + 1;
            elemBN.style.visibility = "visible";
            elemIN.style.visibility = "visible";
            TweenMax.from(elemBN, vm.delay, {
              opacity: 0,
              onComplete: function onComplete() {
                vm.showSwipeLoader = true;
                if (vm.swipeIndex === vm.maxPhotos && vm.swipeIndex !== 0) {} else {
                  vm.swipeIndex++;
                  sessionStorage.setItem("swipeCount", Number(sessionStorage.getItem("swipeCount")) + 1);
                }
                elemBN.style.opacity = 0.99;
                TweenMax.from(elemBN, vm.swipeTime, {
                  top: 0,
                  delay: vm.delay,
                  opacity: 0.6
                });
                TweenMax.from(".current-page", vm.delay, {
                  y: 420,
                  opacity: 0
                });
                TweenMax.from(elemIN, vm.swipeTime, {
                  top: 0,
                  delay: vm.delay,
                  onComplete: function onComplete() {
                    elemBN.style.visibility = "hidden";
                    elemIN.style.visibility = "hidden";
                  }
                });
              }
            });
          }, 10);
        }
      } else {
        if (vm.swipeIndex === vm.maxPhotos) {} else {
          vm.swipeIndex++;
          sessionStorage.setItem("swipeCount", Number(sessionStorage.getItem("swipeCount")) + 1);
        }
      }

      this.noMorePhotos();
    },
    decrement: function decrement() {
      var _this7 = this;

      if (!this.isSwipeZoom) {
        if (vm.swipeIndex !== 0) {
          this.none = "prev";
          var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe") !== null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe").scrollLeft : 0;
          var elemB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-black-" + vm.swipeIndex);
          var elemI = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("swipe-ele-image-" + vm.swipeIndex);
          elemI.style.backgroundImage = "url(" + vm.fullscreenImage(vm.filteredImagesArr[vm.swipeIndex].id, vm.filteredImagesArr[vm.swipeIndex]) + ")";
          elemI.style.backgroundSize = "cover";
          elemI.style.backgroundSize = "auto " + vm.screenH + "px";
          elemI.style.backgroundPositionX = "-" + pos + "px";
          elemI.style.backgroundRepeat = "no-repeat";
          setTimeout(function () {
            _this7.currentPage = vm.swipeIndex;
            elemB.style.visibility = "visible";
            elemI.style.visibility = "visible";
            TweenMax.from(elemB, vm.delay, {
              opacity: 0,
              onComplete: function onComplete() {
                vm.showSwipeLoader = true;
                if (vm.swipeIndex === 0) {} else {
                  vm.swipeIndex--;
                }
                elemB.style.opacity = 0.99;
                TweenMax.from(elemB, vm.swipeTime, {
                  bottom: 0,
                  delay: vm.delay,
                  opacity: 0.6
                });
                TweenMax.from(".current-page", vm.delay, {
                  y: -420,
                  opacity: 0
                });
                TweenMax.from(elemI, vm.swipeTime, {
                  bottom: 0,
                  delay: vm.delay,
                  onComplete: function onComplete() {
                    elemB.style.visibility = "hidden";
                    elemI.style.visibility = "hidden";
                  }
                });
              }
            });
          }, 10);
        }
      } else {
        if (vm.swipeIndex === 0) {} else {
          vm.swipeIndex--;
        }
      }
    },
    easeOut: function easeOut(time) {
      setTimeout(function () {
        var currentScrollPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe") !== null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("layout-swipe").scrollLeft : 0;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("element-" + vm.swipeIndex) !== null) {
          var upperLimit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("element-" + vm.swipeIndex).clientWidth - vm.screenW;
          var lowerLimit = 0;
          var scrollWidth = upperLimit / 2;
          if (currentScrollPosition >= upperLimit - 10 || currentScrollPosition <= lowerLimit + 10) {
            TweenMax.to("#layout-swipe", 1, {
              scrollLeft: scrollWidth,
              ease: Bounce.easeOut
            });
          }
        }
      }, time);
    },


    //for scroll
    getScroll: function getScroll(index) {
      if (index < this.maxPhotos - 1) {
        var cont = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("scroll" + (index + 1));
        var position = cont.scrollLeft;
        position = 0;
        position += 200;
        cont.scrollLeft = position;
      } else {
        this.noMorePhotos();
      }
    },
    changeCnt: function changeCnt() {
      var _this8 = this;

      var isanimate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var img, status;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this8.$store.state.gen.isAPICalling) {
                  _context.next = 15;
                  break;
                }

                img = vm.filteredImagesArr[vm.swipeIndex];

                if (!_this8.isLoggedIn) {
                  _context.next = 13;
                  break;
                }

                if (img.isLiked === false) {
                  img.isLiked = true;
                  img.likes++;
                } else {
                  img.isLiked = false;
                  img.likes--;
                }
                _this8.$store.commit("UPDATE_IS_API_CALLING", { val: true });
                _context.next = 7;
                return vm.$store.dispatch("operationOnPhoto", {
                  pid: img.id,
                  uid: vm.user.uid,
                  operation: "like",
                  uploaderId: img.mediaSourceInformation.photoGrapherId,
                  action: img.isLiked ? "add" : "remove"
                });

              case 7:
                status = _context.sent;

                _this8.$store.commit("UPDATE_IS_API_CALLING", { val: false });
                _this8.$forceUpdate();

                if (isanimate) {
                  TweenMax.to("#wishlist-btn", 0.5, {
                    visibility: "visible",
                    opacity: 0.95
                  });
                  TweenMax.from("#wishlist-btn", 0.5, {
                    visibility: "visible",
                    opacity: 0.95,
                    delay: 0.7
                  });
                }
                _context.next = 15;
                break;

              case 13:
                _this8.$store.commit("snackbar_alert", {
                  msg: " Please sign in to complete your desired action."
                });
                _this8.$router.push({ path: "/login" });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this8);
      }))();
    },
    changeCntCheckin: function changeCntCheckin() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var img, status;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this9.$store.state.gen.isAPICalling) {
                  _context2.next = 14;
                  break;
                }

                img = vm.filteredImagesArr[vm.swipeIndex];

                if (!_this9.isLoggedIn) {
                  _context2.next = 12;
                  break;
                }

                if (img.isCheckedin === false) {
                  img.isCheckedin = true;
                  img.checkins++;
                } else {
                  img.isCheckedin = false;
                  img.checkins--;
                }
                _this9.$store.commit("UPDATE_IS_API_CALLING", { val: true });
                _context2.next = 7;
                return vm.$store.dispatch("operationOnPhoto", {
                  pid: img.id,
                  uid: vm.user.uid,
                  operation: "checkin",
                  uploaderId: img.mediaSourceInformation.photoGrapherId,
                  action: img.isCheckedin ? "add" : "remove"
                });

              case 7:
                status = _context2.sent;

                _this9.$store.commit("UPDATE_IS_API_CALLING", { val: false });
                _this9.$forceUpdate();
                _context2.next = 14;
                break;

              case 12:
                _this9.$store.commit("snackbar_alert", {
                  msg: "Please sign-in to like it. It takes only a few seconds."
                });
                _this9.$router.push({ path: "/login" });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this9);
      }))();
    },


    // CHECK FOR DBL TAP TO ADD IN WISHLIST
    dblTabPhone: function dblTabPhone() {
      if (this.isLoggedIn) {
        if (this.tapped === false) {
          this.tapped = true;
          var tapTimer = setTimeout(function () {
            vm.tapped = false;
          }, 300);
        } else {
          this.isEventDoubleClick = true;
          this.myFunction();
        }
      }
    },
    saveInLs: function saveInLs() {
      var localStorageItem = {
        maxPhotos: this.filteredImagesArr.length,
        swipeIndex: this.swipeIndex,
        filteredImagesArr: this.filteredImagesArr,
        isModeSwipe: this.$store.state.common.isModeSwipe,
        lastSelectedQuery: this.$route.query.loc
      };
      localStorage.setItem("homePageImages", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(localStorageItem));
    },


    // ADD TO WISHLIST FUNCTION HERE
    myFunction: function myFunction() {
      if (!this.filteredImagesArr[vm.swipeIndex].isLiked) {
        this.changeCnt(true);
      }
    },


    // UPDATES THE SWIPE INDEX IN SCROLL MODE
    updateSwipeIndex: function updateSwipeIndex(index) {
      this.swipeIndex = index;
      this.getScroll(index);
    },


    // TOGGLES BETWEEN SCROLL AND SWIPE MODE
    toggleSwipe: function toggleSwipe() {
      var _this10 = this;

      setTimeout(function () {
        if (_this10.screenW < 601) {
          _this10.$store.state.common.isModeSwipe = !_this10.$store.state.common.isModeSwipe;
          _this10.$forceUpdate();

          if (!vm.$store.state.common.isModeSwipe) {
            setTimeout(function () {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_gen__["a" /* ele */])("scroll" + vm.swipeIndex).scrollIntoView();
              vm.getScroll(vm.swipeIndex);
            }, 100);
          } else {
            vm.easeOut(1);
          }
        }
      }, 300);
    },
    checkIfFilterArrFilled: function checkIfFilterArrFilled() {
      var _this11 = this;

      if (this.filteredImagesArr.length === 0) {
        setTimeout(function () {
          _this11.checkIfFilterArrFilled();
        }, 300);
      }
    },
    getSpotType: function getSpotType(filterArr) {
      var defaultSpotType = "Spot";
      if (filterArr != undefined) {
        if (filterArr.spotType.length == 0) {
          return defaultSpotType;
        } else {
          if (filterArr.spotType.length == 1 && filterArr.spotType[0] == "all") {
            return defaultSpotType;
          } else {
            var priorityList = ["rooftop bar", "bar", "airbnb", "apartment", "hotel room", "room", "hotel", "infinity pool", "pool", "restaurant", "cafe"];
            var spotType = defaultSpotType;
            var i = void 0;
            for (i = 0; i < priorityList.length; i++) {
              if (filterArr.spotType.includes(priorityList[i])) {
                spotType = priorityList[i];
                break;
              }
            }
            return this.getCapitalizedString(spotType);
          }
        }
      } else {
        return defaultSpotType;
      }
    },
    getCapitalizedString: function getCapitalizedString(str) {
      if (str) {
        var capitalizedString = str.charAt(0).toUpperCase() + str.slice(1);
        return capitalizedString;
      } else {
        return "";
      }
    },
    getCity: function getCity(filterArr) {
      if (filterArr != undefined) {
        var city_or_country = "";
        if (filterArr.aboutLoc.city != undefined) {
          city_or_country = filterArr.aboutLoc.city;
        } else if (filterArr.aboutLoc.state != undefined) {
          city_or_country = filterArr.aboutLoc.state;
        } else if (filterArr.aboutLoc.subLocality != undefined) {
          city_or_country = filterArr.aboutLoc.subLocality;
        } else {
          city_or_country = filterArr.aboutLoc.country;
        }
        return this.getCapitalizedString(city_or_country);
      } else {
        return "City/Country";
      }
      return obj;
    },
    getSwipeCount: function getSwipeCount() {
      return sessionStorage.getItem("swipeCount");
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(["startAt", "limit", "filteredImagesArr", "maxPhotos", "user", "fetchLocLoader", "isLoggedIn", "_isFirstVisit", "fetchedPicsLength", "morePhotos"]), {
    getWindowInnerHeight: function getWindowInnerHeight() {
      return window.innerHeight;
    },
    getToShowFilter: function getToShowFilter() {
      var obj = {
        filterVal: "Filter"
      };
      var _routes = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_routes).length > 1) {
        for (var i in _routes) {
          if (i !== "loc" && i !== "sortBy" && i !== "createdAt" && i !== "userGeo") {
            obj.filterVal = _routes[i];
          }
        }
      }
      return obj;
    },
    getWidthOfSelOnBasisOfSelCity: function getWidthOfSelOnBasisOfSelCity() {
      if (vm.selectedCity === "Berlin") {
        return "4.7";
      } else if (vm.selectedCity === "worldwide") {
        return "6.7";
      }
    }
  }),
  created: function created() {
    var _this12 = this;

    vm = this;
    var scount = sessionStorage.getItem("swipeCount");
    if (scount == undefined) {
      sessionStorage.setItem("swipeCount", 0);
    } else if (scount < 2) {
      sessionStorage.setItem("swipeCount", 0);
    } else {
      //NOTHING
    }
    var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
    vm.filterViewType = obj.viewType ? obj.viewType : "Everything is better";
    vm.filterLocation = obj.loc && obj.loc !== "Worldwide" ? obj.loc : "Anywhere";
    setTimeout(function () {
      if (_this12.screenW < 600 && _this12.$route.query.view === "list") {
        _this12.$store.state.common.isModeSwipe = false;
        _this12.$store.state.common.swichModesBG = false;
      } else {}
      vm.selectedCity = !!_this12.$route.query.loc ? _this12.$route.query.loc.toLowerCase() : "worldwide";
      if (_this12.$route.query.loc.toLowerCase() === "worldwide" || _this12.$route.query.loc === undefined) {
        var _obj4 = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
        if (_obj4.srt) {
          if (_obj4.srt === "ts") {
            _obj4.srt = "createdAt";
          } else if (_obj4.srt === "lks") {
            _obj4.srt = "likes";
          } else if (_obj4.srt === "km") {
            _obj4.srt = "distance";
          } else {
            _obj4.srt = _obj4.srt;
          }
        }
        vm.$store.commit("getElsewherePics", {
          limit: _this12.limit,
          startAt: 0,
          emotionalAppeal: _obj4.emotionalAppeal === undefined ? ["all"] : [_obj4.emotionalAppeal],
          keywords: _obj4.keywords === undefined ? ["extabs"] : [_obj4.keywords],
          spotType: _obj4.st === undefined ? ["all"] : Array.isArray(_obj4.st) ? _obj4.st : [_obj4.st],
          viewType: _obj4.vt === undefined ? [] : [_obj4.vt],
          sortBy: _obj4.srt,
          userGeo: _obj4.userGeo
        });
      } else {
        // BERLIN
        if (localStorage.getItem("homePageImages") == null) {
          var _obj5 = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
          if (_obj5.srt) {
            if (_obj5.srt === "ts") {
              _obj5.srt = "createdAt";
            } else if (_obj5.srt === "lks") {
              _obj5.srt = "likes";
            } else if (_obj5.srt === "km") {
              _obj5.srt = "distance";
            } else {
              _obj5.srt = _obj5.srt;
            }
          }
          _this12.$store.commit("getMainScreenImages", {
            query: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: _this12.limit,
            uid: _this12.$store.state.auth.user.uid,
            isLoggedIn: _this12.$store.state.auth.isLoggedIn,
            emotionalAppeal: _obj5.emotionalAppeal === undefined ? ["all"] : [_obj5.emotionalAppeal],
            keywords: _obj5.keywords === undefined ? ["extabs"] : [_obj5.keywords],
            spotType: _obj5.st === undefined ? ["all"] : Array.isArray(_obj5.st) ? _obj5.st : [_obj5.st],
            sortBy: _obj5.srt,
            addressIndex: [vm.$route.query.loc],
            userGeo: _obj5.userGeo
          });
        }
      }
    }, 10);
    // }
  },
  mounted: function mounted() {
    var _this13 = this;

    //set target type
    if (this.screenW <= 768) {
      this.target = "_self";
    }
    //gets the query object
    var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.$route.query));
    vm.tab = obj.tab ? obj.tab : "all";
    this.$store.state.hello.filteredImagesArr = [];
    //
    //code regarding the fullscreen mode
    if (localStorage.getItem("showOnboard") === null && screen.width < 600) {
      localStorage.setItem("showOnboard", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(false));
      this.showOnboardings = false;
      for (var i in this.onBoardingData) {
        var img = new Image();
        img.src = this.onBoardingData[i].image;
      }
    } else {
      this.showOnboardings = false; //TRUE//
    }
    if (screen.width < 768) {
      this.showScrollArrow = false;
    }
    this.$store.commit("getLocationFinal");
    window.helloThis = this;
    this.checkIfFilterArrFilled();
    this.isDeviceIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (!this.isDeviceIOS) {
      this.screenH = screen.height;
      this.screenW = screen.width;
      if (this.screenW > 600) {
        this.$store.state.common.isModeSwipe = false;
        this.getScroll(0);
      } else {
        if (!this.showOnboardings) this.easeOut(1);
      }
    } else {
      switch (window.orientation) {
        case 0:
          this.screenH = screen.height;
          this.screenW = screen.width;
          break;

        case 180:
          this.screenH = screen.height;
          this.screenW = screen.width;
          break;

        case -90:
          this.$store.state.common.isModeSwipe = false;
          this.getScroll(0);
          this.screenH = screen.width;
          this.screenW = screen.height;
          break;

        case 90:
          this.$store.state.common.isModeSwipe = false;
          this.getScroll(0);
          this.screenH = screen.width;
          this.screenW = screen.height;
          break;
      }
    }
    var imgArr = JSON.parse(localStorage.getItem("homePageImages"));
    if (imgArr != null) {
      if (!this.$store.state.common.isbottomMenuOpen) {
        this.$store.state.common.isModeSwipe = imgArr.isModeSwipe;
      }
      this.$store.state.hello.filteredImagesArr = imgArr.filteredImagesArr;
      if (this.finalUserLocation != "") {
        this.getLocation();
      }
      this.$store.state.hello.maxPhotos = imgArr.maxPhotos;
      this.swipeIndex = imgArr.swipeIndex;
      this.$forceUpdate();
    } else {
      var _q = vm.$route.query;
      var _qKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_q);
      //
      var _isCityKeyAvailable = false;
      if (_qKeys.includes("loc")) {
        _isCityKeyAvailable = true;
      }
      if (!_isCityKeyAvailable) {
        vm.$router.replace({
          path: "/",
          query: {
            loc: "Berlin"
          }
        });
      } else {}

      //
      // FUNCTION -> GET CITY ON BASIS OF QUERY/BERLIN.
      this.selectedCity = this.$route.query.loc;
    }
    //
    setTimeout(function () {
      //
      if (_this13.$route.query.loc !== vm.selectedCity) {
        vm.selectedCity = _this13.$route.query.loc;
      }
      //
    }, 100);
    //
    this.os = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_identifyOS__["a" /* identifyOS */])();
    this.desktop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_identifyOS__["b" /* identifyDesktop */])();
    this.browser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_identifyOS__["c" /* isChrome */])();
  }
});

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // console.log("props", this.$props);
  },

  methods: {
    saveInLs: function saveInLs() {
      var localStorageItem = {
        maxPhotos: this.$props.maxPhotos,
        swipeIndex: this.$props.swipeIndex,
        filteredImagesArr: this.$props.filteredImagesArr,
        isModeSwipe: this.$props.isModeSwipe,
        lastSelectedQuery: this.$props.lastSelectedQuery
      };
      localStorage.setItem(this.$props.localStorageName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageItem));
    },
    navigateToProfile: function navigateToProfile() {
      this.saveInLs();
      this.$props.isLoggedIn ? this.$router.push({
        path: "/profile",
        query: {
          profile_Id: this.$props.user.uid,
          selected_tab: "checkins"
        }
      }) : this.$router.push("/login");
    },
    navigateToSaved: function navigateToSaved() {
      this.$props.isLoggedIn ? this.$router.push({
        path: "/profile",
        query: {
          profile_Id: this.$props.user.uid,
          selected_tab: "likes"
        }
      }) : this.$router.push("/login");
    },
    navigateToListView: function navigateToListView() {
      this.$props.setSwipeIndex();
      this.$store.state.common.isModeSwipe = false;
    },
    navigateToFullScreen: function navigateToFullScreen() {
      this.$store.state.common.isModeSwipe = true;
      this.$store.state.common.swichModesBG = false;
    },
    navigateToMapView: function navigateToMapView() {
      this.saveInLs();
      this.$router.push({ path: "/map", query: this.$route.query });
      this.$store.state.common.swichModesBG = false;
    }
  },
  props: {
    localStorageName: String,
    screenH: Number,
    screenW: Number,
    view: String,
    maxPhotos: Number,
    swipeIndex: Number,
    isModeSwipe: Boolean,
    filteredImagesArr: Array,
    lastSelectedQuery: String,
    isLoggedIn: Boolean,
    user: Object,
    setSwipeIndex: Function,
    showModeNavigation: Boolean
  }
});

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hello__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Hello__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    hello: __WEBPACK_IMPORTED_MODULE_0__Hello___default.a
  }
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    console.log("LOCAL STROTAGE", this.$props);
  },
  data: function data() {
    return {
      filterSpotType: "all",
      filterLocation: "Where are you going?"
    };
  },

  methods: {
    filterResults: function filterResults(spotType) {}
  },
  props: {
    closeSearchModal: Function
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".search-modal[data-v-26f2177b]{height:100vh;width:100vw;position:fixed;color:#fff;z-index:999;padding:25px 20px;background-color:#000}.search-modal .close-btn[data-v-26f2177b]{display:-webkit-box;display:-ms-flexbox;display:flex}.search-modal .close-btn i[data-v-26f2177b]{font-size:1.5rem}.search-modal .filter-icon[data-v-26f2177b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.search-modal .header[data-v-26f2177b]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:1rem;font-weight:700;font-stretch:normal;font-weight:bolder}.search-modal .spotTypeFilterContainer[data-v-26f2177b]{display:-webkit-box;display:-ms-flexbox;display:flex;color:#fff;margin-top:30px}.search-modal .spotTypeFilterContainer .spotTypeFilterItem button[data-v-26f2177b]{outline:none;font-size:11px;padding:5px;border:none;background-color:transparent;color:#fff}.search-modal .spotTypeFilterContainer .separator[data-v-26f2177b]{width:.5px;border:.5px solid #b9b9b9}.search-modal .search-details[data-v-26f2177b]{cursor:pointer}.search-modal .search-details .filter-container[data-v-26f2177b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:45px;padding:10px 20px;border:1px solid #b9b9b9;border-radius:45px;background-color:#000}.search-modal .search-details .filter-container .filter-location[data-v-26f2177b]{display:-webkit-box;display:-ms-flexbox;display:flex}.search-modal .search-details .filter-container select[data-v-26f2177b]{font-size:11px!important;width:100%}.search-modal .search-details .filter-container select[data-v-26f2177b] :focus,.search-modal .search-details .filter-container select[data-v-26f2177b] :focus-within{outline:none;border:none}.search-modal .search-details .filter-container select option[data-v-26f2177b]{padding:5px;color:#fff;border:1px solid #979797;background-color:#353535;outline:none;font-size:11px}.pointer[data-v-26f2177b]{cursor:pointer}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/homepage/searchModal.vue"],"names":[],"mappings":"AACA,+BACE,aAAc,AACd,YAAa,AACb,eAAgB,AAChB,WAAa,AACb,YAAa,AACb,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,0CACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,4CACM,gBAAkB,CACvB,AACD,4CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACrC,AACD,uCACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,eAAgB,AAChB,gBAAkB,AAClB,oBAAqB,AACrB,kBAAoB,CACvB,AACD,wDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAe,AACf,eAAiB,CACpB,AACD,mFACM,aAAc,AACd,eAAgB,AAChB,YAAa,AACb,YAAa,AACb,6BAA8B,AAC9B,UAAe,CACpB,AACD,mEACM,WAAa,AACb,yBAA4B,CACjC,AACD,+CACI,cAAgB,CACnB,AACD,iEACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,mBAAoB,AACpB,qBAA0B,CAC/B,AACD,kFACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,wEACQ,yBAA2B,AAC3B,UAAY,CACnB,AACD,qKAEU,aAAc,AACd,WAAa,CACtB,AACD,+EACU,YAAa,AACb,WAAa,AACb,yBAA0B,AAC1B,yBAA0B,AAC1B,aAAc,AACd,cAAgB,CACzB,AACD,0BACE,cAAgB,CACjB","file":"searchModal.vue","sourcesContent":["\n.search-modal[data-v-26f2177b] {\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  color: white;\n  z-index: 999;\n  padding: 25px 20px;\n  background-color: #000000;\n}\n.search-modal .close-btn[data-v-26f2177b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.search-modal .close-btn i[data-v-26f2177b] {\n      font-size: 1.5rem;\n}\n.search-modal .filter-icon[data-v-26f2177b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.search-modal .header[data-v-26f2177b] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    font-size: 1rem;\n    font-weight: bold;\n    font-stretch: normal;\n    font-weight: bolder;\n}\n.search-modal .spotTypeFilterContainer[data-v-26f2177b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #ffffff;\n    margin-top: 30px;\n}\n.search-modal .spotTypeFilterContainer .spotTypeFilterItem button[data-v-26f2177b] {\n      outline: none;\n      font-size: 11px;\n      padding: 5px;\n      border: none;\n      background-color: transparent;\n      color: #ffffff;\n}\n.search-modal .spotTypeFilterContainer .separator[data-v-26f2177b] {\n      width: 0.5px;\n      border: 0.5px solid #b9b9b9;\n}\n.search-modal .search-details[data-v-26f2177b] {\n    cursor: pointer;\n}\n.search-modal .search-details .filter-container[data-v-26f2177b] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      min-height: 45px;\n      padding: 10px 20px;\n      border: 1px solid #b9b9b9;\n      border-radius: 45px;\n      background-color: #000000;\n}\n.search-modal .search-details .filter-container .filter-location[data-v-26f2177b] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.search-modal .search-details .filter-container select[data-v-26f2177b] {\n        font-size: 11px !important;\n        width: 100%;\n}\n.search-modal .search-details .filter-container select[data-v-26f2177b] :focus,\n        .search-modal .search-details .filter-container select[data-v-26f2177b] :focus-within {\n          outline: none;\n          border: none;\n}\n.search-modal .search-details .filter-container select option[data-v-26f2177b] {\n          padding: 5px;\n          color: white;\n          border: 1px solid #979797;\n          background-color: #353535;\n          outline: none;\n          font-size: 11px;\n}\n.pointer[data-v-26f2177b] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".bottom-navigation-container[data-v-69d8d15c]{position:fixed;bottom:0;width:100%;z-index:200}.bottom-navigation-container .sticky-footer-common[data-v-69d8d15c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#000;background-color:#d9d9d9;height:50px;padding:5px;-webkit-transition:.8s ease-in-out;transition:.8s ease-in-out}.bottom-navigation-container .sticky-footer-common .user_account[data-v-69d8d15c]{width:1.75em}.bottom-navigation-container .sticky-footer-common i[data-v-69d8d15c]{font-size:22px}.bottom-navigation-container .sticky-footer-common button[data-v-69d8d15c]{outline:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:transparent;border:none;color:#000}.bottom-navigation-container .sticky-footer-common .footer-icons[data-v-69d8d15c]{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#000;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif}.bottom-navigation-container .sticky-footer-common .footer-icons span[data-v-69d8d15c]{display:block;font-size:10px;cursor:pointer}.bottom-navigation-container .sticky-footer-common a[data-v-69d8d15c]{text-decoration:none;color:#000;cursor:pointer}.bottom-navigation-container .mobile-side-icons[data-v-69d8d15c]{right:0}.bottom-navigation-container .container[data-v-69d8d15c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bottom-navigation-container .sticky-footer-mobile[data-v-69d8d15c]{position:fixed;bottom:60px;height:30px;width:150px;display:-webkit-box;display:-ms-flexbox;display:flex;color:#000;background-color:#151515;padding-right:12px;padding-left:12px;border-radius:30px}@media only screen and (min-width:768px){.bottom-navigation-container .sticky-footer-mobile[data-v-69d8d15c]{bottom:36px}}.bottom-navigation-container .sticky-footer-mobile .separator[data-v-69d8d15c]{border-left:.2px solid #5b5b5b}.bottom-navigation-container .sticky-footer-mobile .fullscreen[data-v-69d8d15c]{width:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;cursor:pointer;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.bottom-navigation-container .sticky-footer-mobile .fullscreen [data-v-69d8d15c]{color:#b9b9b9}.bottom-navigation-container .sticky-footer-mobile .fullscreen span[data-v-69d8d15c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:11px}.bottom-navigation-container .sticky-footer-mobile .fullscreen span i[data-v-69d8d15c]{font-size:17px}.bottom-navigation-container .sticky-footer-mobile .map-view[data-v-69d8d15c]{width:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer}.bottom-navigation-container .sticky-footer-mobile .map-view [data-v-69d8d15c]{color:#b9b9b9}.bottom-navigation-container .sticky-footer-mobile .map-view span[data-v-69d8d15c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:11px}.bottom-navigation-container .sticky-footer-mobile .map-view span i[data-v-69d8d15c]{font-size:20px}@media only screen and (min-width:768px){.bottom-navigation-container .fullscreen[data-v-69d8d15c],.bottom-navigation-container .separator[data-v-69d8d15c]{display:none!important}}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/common/bottomNavigation.vue"],"names":[],"mappings":"AACA,8CACE,eAAgB,AAChB,SAAU,AACV,WAAY,AACZ,WAAa,CACd,AACD,oEACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,WAAe,AACf,yBAA0B,AAC1B,YAAa,AACb,YAAa,AACb,mCAAqC,AACrC,0BAA6B,CAChC,AACD,kFACM,YAAc,CACnB,AACD,sEACM,cAAgB,CACrB,AACD,2EACM,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,uBAAwB,AACxB,YAAa,AACb,UAAe,CACpB,AACD,kFACM,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAe,AACf,2IAA+J,CACpK,AACD,uFACM,cAAe,AACf,eAAgB,AAChB,cAAgB,CACrB,AACD,sEACM,qBAAsB,AACtB,WAAe,AACf,cAAgB,CACrB,AACD,iEACI,OAAW,CACd,AACD,yDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,oEACI,eAAgB,AAChB,YAAa,AACb,YAAa,AACb,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAe,AACf,yBAA0B,AAC1B,mBAAoB,AACpB,kBAAmB,AACnB,kBAAoB,CACvB,AACD,yCACA,oEACQ,WAAa,CACpB,CACA,AACD,+EACM,8BAAiC,CACtC,AACD,gFACM,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,eAAgB,AAChB,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CAC3C,AACD,iFACQ,aAAe,CACtB,AACD,qFACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACvB,AACD,uFACU,cAAgB,CACzB,AACD,8EACM,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,cAAgB,CACrB,AACD,+EACQ,aAAe,CACtB,AACD,mFACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACvB,AACD,qFACU,cAAgB,CACzB,AACD,yCAIA,mHACM,sBAAyB,CAC9B,CACA","file":"bottomNavigation.vue","sourcesContent":["\n.bottom-navigation-container[data-v-69d8d15c] {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 200;\n}\n.bottom-navigation-container .sticky-footer-common[data-v-69d8d15c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    color: #000000;\n    background-color: #d9d9d9;\n    height: 50px;\n    padding: 5px;\n    -webkit-transition: 0.8s ease-in-out;\n    transition: 0.8s ease-in-out;\n}\n.bottom-navigation-container .sticky-footer-common .user_account[data-v-69d8d15c] {\n      width: 1.75em;\n}\n.bottom-navigation-container .sticky-footer-common i[data-v-69d8d15c] {\n      font-size: 22px;\n}\n.bottom-navigation-container .sticky-footer-common button[data-v-69d8d15c] {\n      outline: none;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      background: transparent;\n      border: none;\n      color: #000000;\n}\n.bottom-navigation-container .sticky-footer-common .footer-icons[data-v-69d8d15c] {\n      cursor: pointer;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      color: #000000;\n      font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n.bottom-navigation-container .sticky-footer-common .footer-icons span[data-v-69d8d15c] {\n      display: block;\n      font-size: 10px;\n      cursor: pointer;\n}\n.bottom-navigation-container .sticky-footer-common a[data-v-69d8d15c] {\n      text-decoration: none;\n      color: #000000;\n      cursor: pointer;\n}\n.bottom-navigation-container .mobile-side-icons[data-v-69d8d15c] {\n    right: 0px;\n}\n.bottom-navigation-container .container[data-v-69d8d15c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.bottom-navigation-container .sticky-footer-mobile[data-v-69d8d15c] {\n    position: fixed;\n    bottom: 60px;\n    height: 30px;\n    width: 150px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #000000;\n    background-color: #151515;\n    padding-right: 12px;\n    padding-left: 12px;\n    border-radius: 30px;\n}\n@media only screen and (min-width: 768px) {\n.bottom-navigation-container .sticky-footer-mobile[data-v-69d8d15c] {\n        bottom: 36px;\n}\n}\n.bottom-navigation-container .sticky-footer-mobile .separator[data-v-69d8d15c] {\n      border-left: 0.2px solid #5b5b5b;\n}\n.bottom-navigation-container .sticky-footer-mobile .fullscreen[data-v-69d8d15c] {\n      width: 50%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      cursor: pointer;\n      -webkit-box-pack: space-evenly;\n          -ms-flex-pack: space-evenly;\n              justify-content: space-evenly;\n}\n.bottom-navigation-container .sticky-footer-mobile .fullscreen *[data-v-69d8d15c] {\n        color: #b9b9b9;\n}\n.bottom-navigation-container .sticky-footer-mobile .fullscreen span[data-v-69d8d15c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        font-size: 11px;\n}\n.bottom-navigation-container .sticky-footer-mobile .fullscreen span i[data-v-69d8d15c] {\n          font-size: 17px;\n}\n.bottom-navigation-container .sticky-footer-mobile .map-view[data-v-69d8d15c] {\n      width: 50%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      cursor: pointer;\n}\n.bottom-navigation-container .sticky-footer-mobile .map-view *[data-v-69d8d15c] {\n        color: #b9b9b9;\n}\n.bottom-navigation-container .sticky-footer-mobile .map-view span[data-v-69d8d15c] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        font-size: 11px;\n}\n.bottom-navigation-container .sticky-footer-mobile .map-view span i[data-v-69d8d15c] {\n          font-size: 20px;\n}\n@media only screen and (min-width: 768px) {\n.bottom-navigation-container .fullscreen[data-v-69d8d15c] {\n      display: none !important;\n}\n.bottom-navigation-container .separator[data-v-69d8d15c] {\n      display: none !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".bounce[data-v-d17df2ea]{display:inline-block;position:relative;-webkit-animation:bounce-data-v-d17df2ea .5s infinite linear;animation:bounce-data-v-d17df2ea .5s infinite linear;colr:0}.style-icon[data-v-d17df2ea]{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out;opacity:1;text-shadow:2px 2px 2px #333;color:#fff;font-size:2.286em;margin:20px}@-webkit-keyframes bounce{0%{top:0}50%{top:-.2em}70%{top:-.3em}to{top:0}}.v-lazy-image[data-v-d17df2ea]{-webkit-filter:blur(5px);filter:blur(5px);-webkit-transition:-webkit-filter .7s;transition:-webkit-filter .7s;transition:filter .7s;transition:filter .7s,-webkit-filter .7s}.v-lazy-image-loaded[data-v-d17df2ea]{-webkit-filter:blur(0);filter:blur(0)}.go-back-icon-and-fullscreen-mobile[data-v-d17df2ea]{display:none;font-family:Montserrat;padding:3px;text-decoration:none;color:#fff}.go-back-icon-and-fullscreen-mobile i[data-v-d17df2ea]{font-size:12px;margin-right:5px}@media only screen and (min-width:768px){.go-back-icon-and-fullscreen-mobile[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:700;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.go-back-icon-and-fullscreen-mobile .logo[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#bd10e0}}.header-maps-button[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Montserrat;font-size:11px}.header-maps-button .header-map-icon[data-v-d17df2ea]{border-radius:100%;color:#000;padding:1px;background-color:#b9b9b9}.no-photos[data-v-d17df2ea]{padding-top:100px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.no-photos .filters-page[data-v-d17df2ea]{margin-right:2px;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:700;color:#fff;border-radius:6px;margin-left:10px;margin-right:10px;background-color:#000;padding:.625em .9375em;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-max-content;width:-moz-max-content;width:max-content}.long-up-arrow[data-v-d17df2ea]{-webkit-animation:bounce-data-v-d17df2ea 2.6s infinite cubic-bezier(.445,.05,.55,.95);animation:bounce-data-v-d17df2ea 2.6s infinite cubic-bezier(.445,.05,.55,.95);cursor:pointer;width:20px;top:120px;left:calc(50vw - 10px);position:absolute;height:40px;opacity:.7}.gesture-text-swipe-up[data-v-d17df2ea]{top:150px;left:calc(50vw - 105px)}.gesture-text-swipe-up[data-v-d17df2ea],.tap-for-details[data-v-d17df2ea]{font-size:15px;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;position:absolute;color:#fff}.tap-for-details[data-v-d17df2ea]{top:80px;left:calc(50vw - 97px)}.gesture-text-swipe-sides[data-v-d17df2ea]{font-size:15px;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;position:absolute;color:#fff;top:190px;left:calc(50vw - 105px)}.left-right-hand-swipe[data-v-d17df2ea]{-webkit-animation:right-left-movement-data-v-d17df2ea 1.6s infinite cubic-bezier(.445,.05,.55,.95);animation:right-left-movement-data-v-d17df2ea 1.6s infinite cubic-bezier(.445,.05,.55,.95);height:46px;width:60px;left:calc(50vw - 30px);top:100px;position:absolute;opacity:.7}@-webkit-keyframes right-left-movement{0%{-webkit-transform:rotate(-40deg);-moz-transform:rotate(-40deg);-o-transform:rotate(-40deg);-ms-transform:rotate(-40deg)}50%{-webkit-transform:rotate(40deg);transform:rotate(40deg)}to{-webkit-transform:rotate(-40deg);-moz-transform:rotate(-40deg);-o-transform:rotate(-40deg);-ms-transform:rotate(-40deg)}}@keyframes right-left-movement-data-v-d17df2ea{0%{-webkit-transform:rotate(-40deg);-moz-transform:rotate(-40deg);-o-transform:rotate(-40deg);-ms-transform:rotate(-40deg)}50%{-webkit-transform:rotate(40deg);transform:rotate(40deg)}to{-webkit-transform:rotate(-40deg);-moz-transform:rotate(-40deg);-o-transform:rotate(-40deg);-ms-transform:rotate(-40deg)}}.city-spotType[data-v-d17df2ea]{position:absolute;top:30px;right:20px;font-family:Montserrat-Regular,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;padding:5px 12px;border-radius:4px;background-color:rgba(0,0,0,.8);color:#fff}.city-spotType .pointer[data-v-d17df2ea]{cursor:pointer}.flip-reply-icon[data-v-d17df2ea]{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.wav-icon-footer[data-v-d17df2ea]{height:14px}@media only screen and (min-width:768px){.wav-icon-footer[data-v-d17df2ea]{height:10px}}.search-top-city-container[data-v-d17df2ea]{z-index:99;top:0;width:100%;position:fixed;color:#fff;background-color:#2c2c2c;-webkit-transition:top 1s;transition:top 1s}.search-top-city-container .toolbar-content-container[data-v-d17df2ea]{width:100%;padding:.625rem;background-color:#000;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.search-top-city-container .toolbar-content-container .cursor[data-v-d17df2ea]{cursor:pointer}.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-d17df2ea]{font-size:11px;display:none;cursor:pointer}@media only screen and (max-width:768px){.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-d17df2ea]{font-size:11px;display:block}}.search-top-city-container .toolbar-content-container .list-view-text[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:16px;font-weight:700;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:MontSerrat;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.search-top-city-container .toolbar-content-container .list-view-text .logo-color[data-v-d17df2ea]{font-family:MontSerrat;color:#bd10e0}.search-top-city-container .toolbar-content-container .heading-text[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}@media only screen and (min-width:768px){.search-top-city-container .toolbar-content-container .heading-text[data-v-d17df2ea]{display:none}}.search-top-city-container .header-section-3[data-v-d17df2ea]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.search-top-city-container .header-section-3 .pill-container[data-v-d17df2ea]{display:none;border-radius:2rem;border:.5px solid #b9b9b9}@media only screen and (min-width:768px){.search-top-city-container .header-section-3 .pill-container[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex}}.search-top-city-container .header-section-3 .pill[data-v-d17df2ea]{padding:1rem 2rem .4rem}.search-top-city-container .header-section-3 .pill [data-v-d17df2ea]{cursor:pointer;padding:0;margin:0}.search-top-city-container .pills-description[data-v-d17df2ea]{margin-top:5px;display:none}@media only screen and (min-width:768px){.search-top-city-container .pills-description[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex}}.search-top-city-container .pills-description .description-item[data-v-d17df2ea]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:12px}.search-top-city-container .search-city-relative[data-v-d17df2ea]{position:relative;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.search-top-city-container .search-city-relative i[data-v-d17df2ea]{opacity:.6;color:#fff;font-size:1.286em}.search-top-city-container .search-city-relative .i-1[data-v-d17df2ea]{left:20px}.search-top-city-container .search-city-relative .i-2[data-v-d17df2ea]{left:65px}.search-top-city-container .search-city-relative .i-3[data-v-d17df2ea]{right:3em}.search-top-city-container .search-city-relative .i-4[data-v-d17df2ea]{right:22px}.search-top-city-container-hide[data-v-d17df2ea]{top:-100%}.pos-abs[data-v-d17df2ea]{position:absolute}.pos-fixed[data-v-d17df2ea]{position:fixed}.pos-rel[data-v-d17df2ea]{position:relative}@-webkit-keyframes enter{0%{margin-top:-100%}to{margin-top:0}}@keyframes enter-data-v-d17df2ea{0%{margin-top:-100%}to{margin-top:0}}.rotate-enter[data-v-d17df2ea]{-webkit-transition:2s ease-in-out;transition:2s ease-in-out;opacity:1;-webkit-animation:1s enter forwards;animation:1s enter forwards}@-webkit-keyframes leave{0%{margin-top:0}to{margin-top:50%}}@keyframes leave-data-v-d17df2ea{0%{margin-top:0}to{margin-top:50%}}.rotate-leave[data-v-d17df2ea]{-webkit-transition:2s ease-in-out;transition:2s ease-in-out;opacity:.1;-webkit-animation:1s leave infinite;animation:1s leave infinite}.fixed-footer[data-v-d17df2ea]{width:100%;height:94px;background:-webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.6)));background:linear-gradient(transparent,rgba(0,0,0,.6));position:fixed;bottom:0;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.fixed-footer i[data-v-d17df2ea]{z-index:200;font-size:1.2em;color:#50e3c2}.checkin-scroll[data-v-d17df2ea]{opacity:.8;font-size:.84em;text-align:left;line-height:0;letter-spacing:0;position:absolute;left:42.66667vw;opacity:.8!important;z-index:2000}.checkin-scroll i[data-v-d17df2ea]{font-size:1.4em!important}.checkin-swipe[data-v-d17df2ea]{opacity:.8;font-size:.84em;text-align:left;line-height:0;letter-spacing:0;position:absolute;left:26.66667vw;opacity:.8!important;z-index:2000}.checkin-swipe i[data-v-d17df2ea]{font-size:1.4em!important}.share-swipe[data-v-d17df2ea]{opacity:.8;font-size:.84em;text-align:left;line-height:0;letter-spacing:0;position:absolute;left:48vw;opacity:.8!important;z-index:2000}.share-swipe i[data-v-d17df2ea]{font-size:1.4em!important}.footer-container[data-v-d17df2ea]{position:relative;width:100%;height:100%;font-family:inherit;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footer-container .photographer[data-v-d17df2ea]{font-size:10px;text-transform:capitalize;text-align:left;line-height:0;letter-spacing:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footer-container .photographer img[data-v-d17df2ea]{height:2.8125em;width:2.8125em;border-radius:100%;margin-right:.4375em}.footer-container .photographer .image-details[data-v-d17df2ea]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.footer-container .likes[data-v-d17df2ea]{margin-right:25px}.footer-container .location-and-travel-list[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;width:100%;font-size:.75rem;-ms-flex-negative:0;flex-shrink:0}.footer-container .spot-new-scroll[data-v-d17df2ea]{margin-right:20px}.footer-container .spot-new-scroll i[data-v-d17df2ea]{margin-left:5px}.footer-container .want-scroll .want-to-go-button-scroll[data-v-d17df2ea],.footer-container .want-scroll[data-v-d17df2ea]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footer-container .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]{font-size:1rem;background-color:#bd10e0;color:#fff;font-weight:700;padding:10px;border-radius:6px;font-family:Montserrat!important}.footer-container .want-scroll .want-to-go-button-scroll i[data-v-d17df2ea]{margin-right:6px}.footer-container .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]:hover{background-color:#353535;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}.footer-container .want-scroll .want-to-go-circle[data-v-d17df2ea]{font-size:.65rem;background-color:#bd10e0;color:#fff;padding:6px;border-radius:16px}.footer-container .want-scroll .on-travel-list[data-v-d17df2ea],.footer-container .want-scroll .want-to-go-circle[data-v-d17df2ea]{font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footer-container .want-scroll .on-travel-list[data-v-d17df2ea]{background-color:#000;color:#f5a623;border:1px solid #f5a623;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:1rem;padding:10px;border-radius:4px;width:100%;font-family:Montserrat}.footer-container .want-scroll .on-travel-list i[data-v-d17df2ea]{margin-left:6px}.footer-container .want-scroll .on-travel-list[data-v-d17df2ea]:hover{background-color:#fff;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}.image-caption-mobile[data-v-d17df2ea]{font-size:14px;font-family:Montserrat;line-height:1.2;color:#fff}.location-details-mobile[data-v-d17df2ea]{font-size:12px;font-family:Montserrat;color:#fff}.material-icons[data-v-d17df2ea],.md-icons[data-v-d17df2ea]{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-feature-settings:\"liga\";-webkit-font-smoothing:antialiased}.image-container[data-v-d17df2ea]{position:relative}.fullscreen-container[data-v-d17df2ea]{height:100vh}.font-1[data-v-d17df2ea]{font-size:11px}.font-2[data-v-d17df2ea]{font-size:12px}.font-3[data-v-d17df2ea]{font-size:30px}.img-cont[data-v-d17df2ea]{height:100vh;background-color:#2c2c2c;overflow-x:hidden;-webkit-backface-visibility:hidden;-weblit-overflow-scrolling:hidden}.img-cont .relative-img[data-v-d17df2ea]{-weblit-overflow-scrolling:hidden;width:100%;overflow-y:hidden;position:relative;text-decoration:none}.img-cont .relative-img .fullscreen-image[data-v-d17df2ea]{cursor:pointer;width:100%;border-radius:12px}.img-cont .list-view-image-city-spotType[data-v-d17df2ea]{position:absolute;z-index:10;bottom:50px;right:20px;cursor:pointer;font-family:Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;padding:5px 12px;border-radius:4px;background-color:rgba(0,0,0,.8);color:#fff}@media only screen and (max-width:768px){.img-cont .list-view-image-city-spotType[data-v-d17df2ea]{right:10px}}.img-cont .list-view-image-city-spotType .loc-name[data-v-d17df2ea]{font-size:11px;font-weight:400;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;opacity:.5}.img-cont .list-view-image-city-spotType .spot-name[data-v-d17df2ea]{font-size:12px;font-weight:600;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal}.img-cont .last-image .list-view-image-city-spotType[data-v-d17df2ea]{bottom:100px}.img-cont .last-image .icons-footer-2[data-v-d17df2ea]{margin-bottom:50px}.image-container[data-v-d17df2ea]{height:100vh;overflow-x:scroll;overflow-y:hidden}.image-container .fullscreen-image[data-v-d17df2ea]{height:100%;width:100%;-o-object-fit:cover;object-fit:cover}.top-header-icons[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.icons-footer[data-v-d17df2ea]{padding:20px 20px 16px;position:fixed;bottom:0;background:-webkit-gradient(linear,left top,left bottom,from(rgba(51,51,51,0)),to(#333));background:linear-gradient(rgba(51,51,51,0),#333);width:100%;height:118px;color:#fff}.icons-footer i[data-v-d17df2ea]{cursor:pointer}.icons-footer .footer-container[data-v-d17df2ea]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.icons-footer .footer-container .distance i[data-v-d17df2ea]{margin-right:4px}.icons-footer .footer-container .likes[data-v-d17df2ea]{margin-right:25px}.icons-footer .footer-container .likes i[data-v-d17df2ea]{margin-right:5px;font-size:1.2em!important}.icons-footer .footer-container .bottom-menu[data-v-d17df2ea]{left:84.4vw;opacity:.8!important;z-index:2000;font-size:1.2em;height:55px;color:#50e3c2}.current-page[data-v-d17df2ea],.icons-footer .footer-container .bottom-menu[data-v-d17df2ea]{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.current-page[data-v-d17df2ea]{height:100vh;width:100%;font-size:18em;color:#9e9e9e;z-index:5}.touch[data-v-d17df2ea]{-webkit-overflow-scrolling:touch}select[data-v-d17df2ea]{font-size:.857em!important}.swipe-arrow-text[data-v-d17df2ea]{font-size:1.2em;font-weight:600;color:#fff;text-shadow:2px 2px 2px #000}@font-face{font-family:Atma-Medium;font-display:swap;src:url(/static/font/Atma-Medium.ttf)}.view[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:MontSerrat;font-style:normal;font-size:3.714em;color:#fff;text-align:left;letter-spacing:0}.viewzzz-main-z[data-v-d17df2ea]{font-family:MontSerrat;font-weight:600}.swipe-container[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.mobile-side-icons[data-v-d17df2ea]{right:0}.mobile-expand-icon[data-v-d17df2ea]{left:0}.footer-container-main[data-v-d17df2ea]{position:fixed;bottom:50px}.footer-container-main .blurred-bg[data-v-d17df2ea]{background-repeat:no-repeat;background-size:cover;background-attachment:fixed}.footer-container-main .footer-container-new[data-v-d17df2ea]{overflow:hidden;position:relative;margin-bottom:.571em;border-radius:1.143em;padding:5px 16px 5px 20px;opacity:.9}.footer-container-main .footer-container-new .spot-and-distance[data-v-d17df2ea]{z-index:8;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:.786em;color:#fff}.footer-container-main .footer-container-new .spot-and-distance .distance-new[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.footer-container-main .footer-container-new .spot-and-distance .distance-new i[data-v-d17df2ea]{margin-top:-.143em;padding-right:1em;font-size:1em}.footer-container-main .footer-container-new .spot-and-distance .spot-new[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.footer-container-main .footer-container-new .spot-and-distance .spot-new i[data-v-d17df2ea]{font-size:1.714em}.footer-container-main .footer-container-new .actions[data-v-d17df2ea]{z-index:8;margin-top:.429em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:.786em;color:#fff}.footer-container-main .footer-container-new .actions .want-to-go-button[data-v-d17df2ea]{z-index:8;outline:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.footer-container-main .footer-container-new .actions .want-to-go-button i[data-v-d17df2ea]{margin:5px;background-color:#fff;border-radius:100%;z-index:10!important;color:#f5a623;font-size:22px}.footer-container-main .footer-container-new .actions .swipe-up-arrow[data-v-d17df2ea]{margin-left:7px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.footer-container-main .footer-container-new .actions .like-share-fullscreen-container[data-v-d17df2ea]{z-index:8;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.footer-container-main .footer-container-new .actions .like-share-fullscreen-container .fullscreen-box[data-v-d17df2ea]{padding:3px 3px 0}.footer-container-main .footer-container-new .actions .like-share-fullscreen-container i[data-v-d17df2ea]{opacity:.6}.footer-container-main .footer-container-new .actions .mobile_like[data-v-d17df2ea]{margin:5px;font-size:22px}.container-switch-modes[data-v-d17df2ea]{top:-50vh;position:absolute;z-index:4000;height:18.357em;width:95%;border-radius:4px;background:#000;border:1.5px solid #4a4a4a}.container[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-overflow-style:none;background-color:#000;scrollbar-width:none}.arrow-container[data-v-d17df2ea]{width:30px;-webkit-animation:bounce-data-v-d17df2ea 1.6s infinite cubic-bezier(.445,.05,.55,.95);animation:bounce-data-v-d17df2ea 1.6s infinite cubic-bezier(.445,.05,.55,.95);cursor:pointer;height:20px;display:none;position:absolute;bottom:125px;z-index:1}.arrow-down[data-v-d17df2ea]{height:6px;background:#bd10e0;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-transform-origin:0 0;transform-origin:0 0;border-radius:5px}.arrow-down[data-v-d17df2ea]:after{content:\"\";position:absolute;width:100%;height:100%;bottom:0;left:100%;border-radius:5px;background:#bd10e0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}@keyframes bounce-data-v-d17df2ea{50%{-webkit-transform:translateY(-15px);transform:translateY(-15px)}}.list-view-image-container[data-v-d17df2ea]{margin:10px;height:auto}@media only screen and (min-width:768px){.list-view-image-container[data-v-d17df2ea]{height:75vh}}@media only screen and (max-width:600px){.list-view-image-container[data-v-d17df2ea]{max-width:100%}}@media only screen and (min-width:601px) and (max-width:768px){.list-view-image-container[data-v-d17df2ea]{max-width:100%}}@media only screen and (min-width:769px) and (max-width:1024px){.list-view-image-container[data-v-d17df2ea]{max-width:100%}}@media only screen and (min-width:1025px) and (max-width:1240px){.list-view-image-container[data-v-d17df2ea]{max-width:1200px;margin-left:auto;margin-right:auto}}@media only screen and (min-width:1240px){.list-view-image-container[data-v-d17df2ea]{max-width:1440px;margin-left:auto;margin-right:auto}}.list-view-image-container .container-over-image[data-v-d17df2ea]{position:absolute;z-index:10;top:15px;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;right:15px;display:-webkit-box;display:-ms-flexbox;display:flex}.list-view-image-container .container-over-image .share-scroll[data-v-d17df2ea]{color:#fff;-webkit-transform:scaleX(-1);transform:scaleX(-1)}.list-view-image-container .icon-container[data-v-d17df2ea]{padding:3px;border-radius:50%;background-color:rgba(0,0,0,.4);height:30px;width:30px}.list-view-image-container .card-top[data-v-d17df2ea]{display:none;background-color:#353535;padding:10px;color:#fff;margin-bottom:-10px;border-radius:12px 12px 0 0}.list-view-image-container .card-top .image-caption[data-v-d17df2ea]{font-size:14px;font-weight:600;text-transform:uppercase;margin-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.list-view-image-container .card-top .location-details[data-v-d17df2ea]{margin-bottom:.2rem}.list-view-image-container .card-top .location-details .loc-name[data-v-d17df2ea],.list-view-image-container .card-top .location-details .spot-name[data-v-d17df2ea]{font-size:12px;line-height:1.2}.list-view-image-container .icons-footer-2[data-v-d17df2ea]{padding:10px 0 0;background:#000;-ms-flex-pack:distribute;justify-content:space-around;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;color:#fff;margin-top:-12px;position:relative;border-radius:0 0 12px 12px}.list-view-image-container .icons-footer-2 i[data-v-d17df2ea]{font-size:20px;cursor:pointer}.image-details-mobile[data-v-d17df2ea]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:10px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.image-details-mobile .image-caption[data-v-d17df2ea]{font-size:14px;text-transform:uppercase;margin-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.image-details-mobile .location-details[data-v-d17df2ea]{margin-bottom:.2rem}.image-details-mobile .location-details .loc-name[data-v-d17df2ea],.image-details-mobile .location-details .spot-name[data-v-d17df2ea]{font-size:12px;line-height:1.2}.image-details-mobile .photographer[data-v-d17df2ea]{margin-top:10px;margin-bottom:10px}.list-view-images-container[data-v-d17df2ea]{margin-bottom:100px;padding:10px;margin-top:130px;background-color:#2c2c2c}@media only screen and (min-width:768px){.list-view-images-container[data-v-d17df2ea]{margin-top:100px;margin-bottom:100px}}.image-details-desktop[data-v-d17df2ea]{color:#fff;background-color:#000;width:30%;border-radius:0 12px 12px 0;padding:20px;margin-left:-5px;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.image-details-desktop .image-caption[data-v-d17df2ea]{font-size:1.5rem}.image-details-desktop .image-location[data-v-d17df2ea]{font-size:.75rem}.image-details-desktop .details-btn[data-v-d17df2ea]{font-size:12px;font-weight:600;text-decoration:none;color:#fff;padding:10px 20px;text-align:center;margin-top:20px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;border-radius:4px;border:1px solid #fff}.image-details-desktop .details-btn[data-v-d17df2ea]:hover{background-color:#fff;color:#000;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}.image-details-desktop .footer-container-desktop[data-v-d17df2ea]{position:relative;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;font-family:inherit;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.image-details-desktop .footer-container-desktop .photograher-likes-share[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px}.image-details-desktop .footer-container-desktop .photographer-container[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:distribute;justify-content:space-around}.image-details-desktop .footer-container-desktop .photographer-container .photographer[data-v-d17df2ea]{font-size:.6875em;text-transform:capitalize;text-align:left;letter-spacing:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.image-details-desktop .footer-container-desktop .photographer-container .photographer img[data-v-d17df2ea]{height:2.8125em;width:2.8125em;border-radius:100%;margin-right:.4375em}.image-details-desktop .footer-container-desktop .photographer-container .photographer .image-details[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.image-details-desktop .footer-container-desktop .likes[data-v-d17df2ea]{margin-right:20px;cursor:pointer}.image-details-desktop .footer-container-desktop .location-and-travel-list[data-v-d17df2ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;font-size:.75rem;-ms-flex-negative:0;flex-shrink:0;width:100%}.image-details-desktop .footer-container-desktop .spot-new-scroll[data-v-d17df2ea]{margin-right:20px}.image-details-desktop .footer-container-desktop .spot-new-scroll i[data-v-d17df2ea]{margin-left:5px}.image-details-desktop .footer-container-desktop .want-scroll[data-v-d17df2ea]{width:100%}.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]{font-size:1rem;background-color:#bd10e0;color:#fff;font-weight:700;padding:10px;border-radius:4px;width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:10px;font-family:Montserrat}.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll i[data-v-d17df2ea]{margin-left:6px;font-weight:700;font-size:1.5rem}.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]:hover{background-color:#353535;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list[data-v-d17df2ea]{background-color:#000;color:#f5a623;font-weight:700;border:1px solid #f5a623;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:1rem;padding:10px;border-radius:4px;width:100%;margin-top:10px;font-family:Montserrat}.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list i[data-v-d17df2ea]{margin-left:6px}.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list[data-v-d17df2ea]:hover{background-color:#fff;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}.pointer[data-v-d17df2ea]{cursor:pointer}.check-prices[data-v-d17df2ea]{font-size:1rem;background-color:#b9b9b9;color:#000;font-weight:700;padding:10px;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;text-decoration:none;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-family:Montserrat!important}.check-prices i[data-v-d17df2ea]{margin-right:6px}.check-prices[data-v-d17df2ea]:hover{background-color:#353535;color:#fff;-webkit-transition:background-color .1s linear;transition:background-color .1s linear}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/Hello.vue"],"names":[],"mappings":"AACA,yBACE,qBAAsB,AACtB,kBAAmB,AACnB,6DAA+D,AAC/D,qDAAuD,AACvD,MAAU,CACX,AACD,6BACE,uCAAyC,AACzC,+BAAiC,AACjC,UAAW,AACX,6BAAiC,AACjC,WAAe,AACf,kBAAmB,AACnB,WAAa,CACd,AACD,0BACA,GACI,KAAO,CACV,AACD,IACI,SAAY,CACf,AACD,IACI,SAAY,CACf,AACD,GACI,KAAO,CACV,CACA,AAeD,+BACE,yBAA0B,AAClB,iBAAkB,AAC1B,sCAAwC,AACxC,8BAAgC,AAChC,sBAAwB,AACxB,wCAA6C,CAC9C,AACD,sCACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,qDACE,aAAc,AACd,uBAAwB,AACxB,YAAa,AACb,qBAAsB,AACtB,UAAa,CACd,AACD,uDACI,eAAgB,AAChB,gBAAkB,CACrB,AACD,yCACA,qDACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,AAClB,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,2DACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,aAAe,CACtB,CACA,AACD,qCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACxB,cAAgB,CACjB,AACD,sDACI,mBAAoB,AACpB,WAAe,AACf,YAAa,AACb,wBAA0B,CAC7B,AACD,4BACE,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,0CACI,iBAAkB,AAClB,4IAA+J,AAC/J,eAAgB,AAChB,gBAAkB,AAClB,WAAe,AACf,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,sBAA0B,AAC1B,uBAA0B,AAC1B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACtB,AACD,gCACE,sFAAgG,AACxF,8EAAwF,AAChG,eAAgB,AAChB,WAAY,AACZ,UAAW,AACX,uBAAwB,AACxB,kBAAmB,AACnB,YAAa,AACb,UAAa,CACd,AAaD,wCAIE,UAAW,AAEX,uBAAyB,CAC1B,AACD,0EAPE,eAAgB,AAChB,4IAA+J,AAC/J,kBAAmB,AAEnB,UAAa,CAUd,AAPD,kCAIE,SAAU,AAEV,sBAAwB,CACzB,AACD,2CACE,eAAgB,AAChB,4IAA+J,AAC/J,kBAAmB,AACnB,WAAa,AACb,UAAW,AACX,uBAAyB,CAC1B,AACD,wCACE,mGAA6G,AACrG,2FAAqG,AAC7G,YAAa,AACb,WAAY,AACZ,uBAAwB,AACxB,UAAW,AACX,kBAAmB,AACnB,UAAa,CACd,AACD,uCACA,GACI,iCAAkC,AAClC,8BAA+B,AAC/B,4BAA6B,AAC7B,4BAA8B,CACjC,AACD,IACI,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,GACI,iCAAkC,AAClC,8BAA+B,AAC/B,4BAA6B,AAC7B,4BAA8B,CACjC,CACA,AACD,+CACA,GACI,iCAAkC,AAClC,8BAA+B,AAC/B,4BAA6B,AAC7B,4BAA8B,CACjC,AACD,IACI,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,GACI,iCAAkC,AAClC,8BAA+B,AAC/B,4BAA6B,AAC7B,4BAA8B,CACjC,CACA,AACD,gCACE,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,4IAA+J,AAC/J,iBAAkB,AAClB,kBAAmB,AACnB,gCAAqC,AACrC,UAAe,CAChB,AACD,yCACI,cAAgB,CACnB,AACD,kCACE,6BAA8B,AACtB,oBAAsB,CAC/B,AACD,kCACE,WAAa,CACd,AACD,yCACA,kCACM,WAAa,CAClB,CACA,AACD,4CACE,WAAY,AACZ,MAAO,AACP,WAAY,AACZ,eAAgB,AAChB,WAAa,AACb,yBAA0B,AAC1B,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,uEACI,WAAY,AACZ,gBAAkB,AAClB,sBAA0B,AAC1B,WAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,+EACM,cAAgB,CACrB,AACD,6FACM,eAAgB,AAChB,aAAc,AACd,cAAgB,CACrB,AACD,yCACA,6FACU,eAAgB,AAChB,aAAe,CACxB,CACA,AACD,uFACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,gBAAkB,AAClB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,uBAAwB,AACxB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,mGACQ,uBAAwB,AACxB,aAAe,CACtB,AACD,qFACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,oBAAsB,CACnC,AACD,yCACA,qFACU,YAAc,CACvB,CACA,AACD,8DACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,8EACM,aAAc,AACd,mBAAoB,AACpB,yBAA4B,CACjC,AACD,yCACA,8EACU,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACvB,CACA,AACD,oEACM,uBAA+B,CACpC,AACD,qEACQ,eAAgB,AAChB,UAAW,AACX,QAAU,CACjB,AACD,+DACI,eAAgB,AAChB,YAAc,CACjB,AACD,yCACA,+DACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,CACA,AACD,iFACM,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,cAAgB,CACrB,AACD,kEACI,kBAAmB,AACnB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,oEACM,WAAa,AACb,WAAa,AACb,iBAAmB,CACxB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,SAAW,CAChB,AACD,uEACM,UAAY,CACjB,AACD,iDACE,SAAW,CACZ,AACD,0BACE,iBAAmB,CACpB,AACD,4BACE,cAAgB,CACjB,AACD,0BACE,iBAAmB,CACpB,AACD,yBACA,GACI,gBAAkB,CACrB,AACD,GACI,YAAc,CACjB,CACA,AACD,iCACA,GACI,gBAAkB,CACrB,AACD,GACI,YAAc,CACjB,CACA,AACD,+BACE,kCAAmC,AACnC,0BAA2B,AAC3B,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,yBACA,GACI,YAAc,CACjB,AACD,GACI,cAAgB,CACnB,CACA,AACD,iCACA,GACI,YAAc,CACjB,AACD,GACI,cAAgB,CACnB,CACA,AACD,+BACE,kCAAmC,AACnC,0BAA2B,AAC3B,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,+BACE,WAAY,AACZ,YAAa,AACb,8FAA4G,AAC5G,uDAAkE,AAClE,eAAgB,AAChB,SAAU,AACV,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CAC/B,AACD,iCACI,YAAa,AACb,gBAAiB,AACjB,aAAe,CAClB,AACD,iCACE,WAAa,AACb,gBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,AACxB,YAAc,CACf,AACD,mCACI,yBAA4B,CAC/B,AACD,gCACE,WAAa,AACb,gBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,AACxB,YAAc,CACf,AACD,kCACI,yBAA4B,CAC/B,AACD,8BACE,WAAa,AACb,gBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,UAAW,AACX,qBAAwB,AACxB,YAAc,CACf,AACD,gCACI,yBAA4B,CAC/B,AACD,mCACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,iDACI,eAAgB,AAChB,0BAA2B,AAC3B,gBAAiB,AACjB,cAAe,AACf,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,qDACM,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,oBAAuB,CAC5B,AACD,gEACM,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACpC,AACD,0CACI,iBAAmB,CACtB,AACD,6DACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,WAAY,AACZ,iBAAmB,AACnB,oBAAqB,AACjB,aAAe,CACtB,AACD,oDACI,iBAAmB,CACtB,AACD,sDACM,eAAiB,CACtB,AAaD,0HAXI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAoB/B,AAlBD,0EACM,eAAgB,AAChB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,AAClB,aAAc,AACd,kBAAmB,AAWnB,gCAAmC,CACxC,AACD,4EACQ,gBAAkB,CACzB,AACD,gFACQ,yBAA0B,AAC1B,+CAAkD,AAClD,sCAA0C,CACjD,AACD,mEACM,iBAAmB,AACnB,yBAA0B,AAC1B,WAAe,AAEf,YAAa,AACb,kBAAoB,CAOzB,AACD,mIAVM,gBAAkB,AAGlB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAsBjC,AApBD,gEACM,sBAAwB,AACxB,cAAe,AAEf,yBAA0B,AAI1B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAKhC,eAAgB,AAChB,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,sBAAwB,CAC7B,AACD,kEACQ,eAAiB,CACxB,AACD,sEACQ,sBAAwB,AACxB,+CAAkD,AAClD,sCAA0C,CACjD,AACD,uCACE,eAAgB,AAChB,uBAAwB,AACxB,gBAAiB,AACjB,UAAY,CACb,AACD,0CACE,eAAgB,AAChB,uBAAwB,AACxB,UAAY,CACb,AACD,4DAEE,2BAA8B,AAC9B,gBAAoB,AACpB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,sBAAuB,AACvB,oBAAqB,AACrB,qBAAsB,AACtB,mBAAoB,AACpB,iBAAkB,AAClB,cAAe,AACf,qCAAsC,AACtC,kCAAoC,CACrC,AACD,kCACE,iBAAmB,CACpB,AACD,uCACE,YAAc,CACf,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,cAAgB,CACjB,AACD,2BACE,aAAc,AACd,yBAA0B,AAC1B,kBAAmB,AACnB,mCAAoC,AACpC,iCAAmC,CACpC,AACD,yCACI,kCAAmC,AACnC,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,oBAAsB,CACzB,AACD,2DACM,eAAgB,AAChB,WAAY,AACZ,kBAAoB,CACzB,AACD,0DACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,oIAAuJ,AACvJ,iBAAkB,AAClB,kBAAmB,AACnB,gCAAqC,AACrC,UAAe,CAClB,AACD,yCACA,0DACQ,UAAY,CACnB,CACA,AACD,oEACM,eAAgB,AAChB,gBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,sBAAuB,AACvB,UAAa,CAClB,AACD,qEACM,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,qBAAuB,CAC5B,AACD,sEACI,YAAc,CACjB,AACD,uDACI,kBAAoB,CACvB,AACD,kCACE,aAAc,AACd,kBAAmB,AACnB,iBAAmB,CACpB,AACD,oDACI,YAAa,AACb,WAAY,AACZ,oBAAqB,AAClB,gBAAkB,CACxB,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAC7B,AACD,+BAGE,uBAAmB,AAEnB,eAAgB,AAChB,SAAU,AACV,yFAAoG,AACpG,kDAA0D,AAC1D,WAAY,AACZ,aAAc,AACd,UAAa,CACd,AACD,iCACI,cAAgB,CACnB,AACD,iDACI,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,6DACM,gBAAkB,CACvB,AACD,wDACM,iBAAmB,CACxB,AACD,0DACQ,iBAAkB,AAClB,yBAA4B,CACnC,AACD,8DAEM,YAAa,AACb,qBAAwB,AACxB,aAAc,AACd,gBAAiB,AACjB,YAAa,AAUb,aAAe,CACpB,AACD,6FAjBM,kBAAmB,AAMnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAmBrC,AAhBD,+BACE,aAAc,AACd,WAAY,AAWZ,eAAgB,AAChB,cAAe,AACf,SAAW,CACZ,AACD,wBACE,gCAAkC,CACnC,AACD,wBACE,0BAA8B,CAC/B,AACD,mCACE,gBAAiB,AACjB,gBAAiB,AACjB,WAAa,AACb,4BAAiC,CAClC,AACD,WACE,wBAAyB,AACzB,kBAAmB,AACnB,qCAAuC,CACxC,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,uBAAwB,AACxB,kBAAmB,AACnB,kBAAmB,AACnB,WAAa,AACb,gBAAiB,AACjB,gBAAkB,CACnB,AACD,iCACE,uBAAwB,AACxB,eAAiB,CAClB,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,oCACE,OAAW,CACZ,AACD,qCACE,MAAU,CACX,AACD,wCACE,eAAgB,AAChB,WAAa,CACd,AACD,oDACI,4BAA6B,AAC7B,sBAAuB,AACvB,2BAA6B,CAChC,AACD,8DACI,gBAAiB,AACjB,kBAAmB,AACnB,qBAAuB,AACvB,sBAAuB,AACvB,0BAA2B,AAC3B,UAAa,CAChB,AACD,iFACM,UAAW,AACX,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,iBAAmB,AACnB,UAAa,CAClB,AACD,+FACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACvC,AACD,iGACU,mBAAqB,AACrB,kBAAmB,AACnB,aAAe,CACxB,AACD,2FACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACvC,AACD,6FACU,iBAAmB,CAC5B,AACD,uEACM,UAAW,AACX,kBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,iBAAmB,AACnB,UAAa,CAClB,AACD,0FACQ,UAAW,AACX,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACzC,AACD,4FACU,WAAY,AACZ,sBAAwB,AACxB,mBAAoB,AACpB,qBAAuB,AACvB,cAAe,AACf,cAAgB,CACzB,AACD,uFACQ,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACrC,AACD,wGACQ,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACrC,AACD,wHACU,iBAAyB,CAClC,AACD,0GACU,UAAa,CACtB,AACD,oFACQ,WAAY,AACZ,cAAgB,CACvB,AACD,yCACE,UAAW,AACX,kBAAmB,AACnB,aAAc,AACd,gBAAiB,AACjB,UAAuB,AACvB,kBAAmB,AACnB,gBAAkB,AAClB,0BAA4B,CAC7B,AACD,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,wBAAyB,AACzB,sBAA0B,AAE1B,oBAAsB,CACvB,AACD,kCACE,WAAY,AAEZ,sFAAgG,AACxF,8EAAwF,AAChG,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,aAAc,AACd,SAAW,CACZ,AACD,6BACE,WAAY,AACZ,mBAAoB,AACpB,gCAAiC,AACzB,wBAAyB,AACjC,6BAAgC,AACxB,qBAAwB,AAChC,iBAAmB,CACpB,AACD,mCACE,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,SAAU,AACV,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,iCAAkC,AAC1B,yBAA0B,AAClC,gCAAkC,AAC1B,uBAA0B,CACnC,AACD,kCACA,IACI,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,4CACE,YAAa,AACb,WAAa,CACd,AACD,yCACA,4CACM,WAAa,CAClB,CACA,AACD,yCACA,4CACM,cAAgB,CACrB,CACA,AACD,+DACA,4CACM,cAAgB,CACrB,CACA,AACD,gEACA,4CACM,cAAgB,CACrB,CACA,AACD,iEACA,4CACM,iBAAkB,AAClB,iBAAkB,AAClB,iBAAmB,CACxB,CACA,AACD,0CACA,4CACM,iBAAkB,AAClB,iBAAkB,AAClB,iBAAmB,CACxB,CACA,AACD,kEACI,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,gFACM,WAAe,AACf,6BAA8B,AACtB,oBAAsB,CACnC,AACD,4DACI,YAAa,AACb,kBAAmB,AACnB,gCAAqC,AACrC,YAAa,AACb,UAAY,CACf,AACD,sDACI,aAAc,AACd,yBAA0B,AAC1B,aAAc,AACd,WAAe,AACf,oBAAqB,AACrB,2BAAiC,CACpC,AACD,qEACM,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACrC,AACD,wEACM,mBAAsB,CAC3B,AAKD,qKACQ,eAAgB,AAChB,eAAiB,CACxB,AACD,4DACI,iBAAoB,AACpB,gBAAoB,AACpB,yBAA0B,AACtB,6BAA8B,AAClC,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,2BAA6B,CAChC,AACD,8DACM,eAAgB,AAChB,cAAgB,CACrB,AACD,uCACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,sDACI,eAAgB,AAChB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,yDACI,mBAAsB,CACzB,AAKD,uIACM,eAAgB,AAChB,eAAiB,CACtB,AACD,qDACI,gBAAiB,AACjB,kBAAoB,CACvB,AACD,6CACE,oBAAqB,AACrB,aAAc,AACd,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,yCACA,6CACM,iBAAkB,AAClB,mBAAqB,CAC1B,CACA,AACD,wCACE,WAAe,AACf,sBAA0B,AAC1B,UAAW,AACX,4BAA6B,AAC7B,aAAc,AACd,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,uDACI,gBAAkB,CACrB,AACD,wDACI,gBAAmB,CACtB,AACD,qDACI,eAAgB,AAChB,gBAAiB,AACjB,qBAAsB,AACtB,WAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAwB,CAC3B,AACD,2DACM,sBAA0B,AAC1B,WAAe,AACf,+CAAkD,AAClD,sCAA0C,CAC/C,AACD,kEACI,kBAAmB,AACnB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,2FACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAY,AACZ,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACzB,AACD,0FACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,4BAA8B,CACvC,AACD,wGACQ,kBAAoB,AACpB,0BAA2B,AAC3B,gBAAiB,AACjB,iBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACnC,AACD,4GACU,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,oBAAuB,CAChC,AACD,uHACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACxC,AACD,yEACM,kBAAmB,AACnB,cAAgB,CACrB,AACD,4FACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,iBAAmB,AACnB,oBAAqB,AACjB,cAAe,AACnB,UAAY,CACjB,AACD,mFACM,iBAAmB,CACxB,AACD,qFACQ,eAAiB,CACxB,AACD,+EACM,UAAY,CACjB,AACD,yGACQ,eAAgB,AAChB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,AAClB,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,sBAAwB,CAC/B,AACD,2GACU,gBAAiB,AACjB,gBAAkB,AAClB,gBAAkB,CAC3B,AACD,+GACU,yBAA0B,AAC1B,+CAAkD,AAClD,sCAA0C,CACnD,AACD,+FACQ,sBAAwB,AACxB,cAAe,AACf,gBAAkB,AAClB,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAEhC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAgB,AAChB,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,sBAAwB,CAC/B,AACD,iGACU,eAAiB,CAC1B,AACD,qGACU,sBAA0B,AAC1B,+CAAkD,AAClD,sCAA0C,CACnD,AACD,0BACE,cAAgB,CACjB,AACD,+BACE,eAAgB,AAChB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,AAClB,aAAc,AACd,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AACtB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAY,AACZ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAmC,CACpC,AACD,iCACI,gBAAkB,CACrB,AACD,qCACI,yBAA0B,AAC1B,WAAa,AACb,+CAAkD,AAClD,sCAA0C,CAC7C","file":"Hello.vue","sourcesContent":["\n.bounce[data-v-d17df2ea] {\n  display: inline-block;\n  position: relative;\n  -webkit-animation: bounce-data-v-d17df2ea 0.5s infinite linear;\n  animation: bounce-data-v-d17df2ea 0.5s infinite linear;\n  colr: 000;\n}\n.style-icon[data-v-d17df2ea] {\n  -webkit-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  opacity: 1;\n  text-shadow: 2px 2px 2px #333333;\n  color: #ffffff;\n  font-size: 2.286em;\n  margin: 20px;\n}\n@-webkit-keyframes bounce {\n0% {\n    top: 0;\n}\n50% {\n    top: -0.2em;\n}\n70% {\n    top: -0.3em;\n}\n100% {\n    top: 0;\n}\n}\n@keyframes bounce-data-v-d17df2ea {\n0% {\n    top: 0;\n}\n50% {\n    top: -0.2em;\n}\n70% {\n    top: -0.3em;\n}\n100% {\n    top: 0;\n}\n}\n.v-lazy-image[data-v-d17df2ea] {\n  -webkit-filter: blur(5px);\n          filter: blur(5px);\n  -webkit-transition: -webkit-filter 0.7s;\n  transition: -webkit-filter 0.7s;\n  transition: filter 0.7s;\n  transition: filter 0.7s, -webkit-filter 0.7s;\n}\n.v-lazy-image-loaded[data-v-d17df2ea] {\n  -webkit-filter: blur(0);\n          filter: blur(0);\n}\n.go-back-icon-and-fullscreen-mobile[data-v-d17df2ea] {\n  display: none;\n  font-family: Montserrat;\n  padding: 3px;\n  text-decoration: none;\n  color: white;\n}\n.go-back-icon-and-fullscreen-mobile i[data-v-d17df2ea] {\n    font-size: 12px;\n    margin-right: 5px;\n}\n@media only screen and (min-width: 768px) {\n.go-back-icon-and-fullscreen-mobile[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-weight: bold;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.go-back-icon-and-fullscreen-mobile .logo[data-v-d17df2ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: baseline;\n            -ms-flex-align: baseline;\n                align-items: baseline;\n        color: #bd10e0;\n}\n}\n.header-maps-button[data-v-d17df2ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: Montserrat;\n  font-size: 11px;\n}\n.header-maps-button .header-map-icon[data-v-d17df2ea] {\n    border-radius: 100%;\n    color: #000000;\n    padding: 1px;\n    background-color: #b9b9b9;\n}\n.no-photos[data-v-d17df2ea] {\n  padding-top: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.no-photos .filters-page[data-v-d17df2ea] {\n    margin-right: 2px;\n    font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    font-size: 12px;\n    font-weight: bold;\n    color: #ffffff;\n    border-radius: 6px;\n    margin-left: 10px;\n    margin-right: 10px;\n    background-color: #000000;\n    padding: 0.625em 0.9375em;\n    text-decoration: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n.long-up-arrow[data-v-d17df2ea] {\n  -webkit-animation: bounce-data-v-d17df2ea 2600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n          animation: bounce-data-v-d17df2ea 2600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  cursor: pointer;\n  width: 20px;\n  top: 120px;\n  left: calc(50vw - 10px);\n  position: absolute;\n  height: 40px;\n  opacity: 0.7;\n}\n@keyframes bounce-data-v-d17df2ea {\n50% {\n    -webkit-transform: translateY(-30px);\n            transform: translateY(-30px);\n    opacity: 0.5;\n}\n100% {\n    -webkit-transform: translateY(-60px);\n            transform: translateY(-60px);\n    opacity: 0;\n}\n}\n.gesture-text-swipe-up[data-v-d17df2ea] {\n  font-size: 15px;\n  font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  position: absolute;\n  top: 150px;\n  color: white;\n  left: calc(50vw - 105px);\n}\n.tap-for-details[data-v-d17df2ea] {\n  font-size: 15px;\n  font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  position: absolute;\n  top: 80px;\n  color: white;\n  left: calc(50vw - 97px);\n}\n.gesture-text-swipe-sides[data-v-d17df2ea] {\n  font-size: 15px;\n  font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  position: absolute;\n  color: white;\n  top: 190px;\n  left: calc(50vw - 105px);\n}\n.left-right-hand-swipe[data-v-d17df2ea] {\n  -webkit-animation: right-left-movement-data-v-d17df2ea 1600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n          animation: right-left-movement-data-v-d17df2ea 1600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  height: 46px;\n  width: 60px;\n  left: calc(50vw - 30px);\n  top: 100px;\n  position: absolute;\n  opacity: 0.7;\n}\n@-webkit-keyframes right-left-movement {\n0% {\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n}\n50% {\n    -webkit-transform: rotate(40deg);\n    transform: rotate(40deg);\n}\n100% {\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n}\n}\n@keyframes right-left-movement-data-v-d17df2ea {\n0% {\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n}\n50% {\n    -webkit-transform: rotate(40deg);\n    transform: rotate(40deg);\n}\n100% {\n    -webkit-transform: rotate(-40deg);\n    -moz-transform: rotate(-40deg);\n    -o-transform: rotate(-40deg);\n    -ms-transform: rotate(-40deg);\n}\n}\n.city-spotType[data-v-d17df2ea] {\n  position: absolute;\n  top: 30px;\n  right: 20px;\n  font-family: \"Montserrat-Regular\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  padding: 5px 12px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #ffffff;\n}\n.city-spotType .pointer[data-v-d17df2ea] {\n    cursor: pointer;\n}\n.flip-reply-icon[data-v-d17df2ea] {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n.wav-icon-footer[data-v-d17df2ea] {\n  height: 14px;\n}\n@media only screen and (min-width: 768px) {\n.wav-icon-footer[data-v-d17df2ea] {\n      height: 10px;\n}\n}\n.search-top-city-container[data-v-d17df2ea] {\n  z-index: 99;\n  top: 0;\n  width: 100%;\n  position: fixed;\n  color: white;\n  background-color: #2c2c2c;\n  -webkit-transition: top 1s;\n  transition: top 1s;\n}\n.search-top-city-container .toolbar-content-container[data-v-d17df2ea] {\n    width: 100%;\n    padding: 0.625rem;\n    background-color: #000000;\n    color: white;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.search-top-city-container .toolbar-content-container .cursor[data-v-d17df2ea] {\n      cursor: pointer;\n}\n.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-d17df2ea] {\n      font-size: 11px;\n      display: none;\n      cursor: pointer;\n}\n@media only screen and (max-width: 768px) {\n.search-top-city-container .toolbar-content-container .fullscreen-mode-text[data-v-d17df2ea] {\n          font-size: 11px;\n          display: block;\n}\n}\n.search-top-city-container .toolbar-content-container .list-view-text[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      font-size: 16px;\n      font-weight: bold;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      font-family: MontSerrat;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.search-top-city-container .toolbar-content-container .list-view-text .logo-color[data-v-d17df2ea] {\n        font-family: MontSerrat;\n        color: #bd10e0;\n}\n.search-top-city-container .toolbar-content-container .heading-text[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n}\n@media only screen and (min-width: 768px) {\n.search-top-city-container .toolbar-content-container .heading-text[data-v-d17df2ea] {\n          display: none;\n}\n}\n.search-top-city-container .header-section-3[data-v-d17df2ea] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.search-top-city-container .header-section-3 .pill-container[data-v-d17df2ea] {\n      display: none;\n      border-radius: 2rem;\n      border: 0.5px solid #b9b9b9;\n}\n@media only screen and (min-width: 768px) {\n.search-top-city-container .header-section-3 .pill-container[data-v-d17df2ea] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n}\n}\n.search-top-city-container .header-section-3 .pill[data-v-d17df2ea] {\n      padding: 1rem 2rem 0.4rem 2rem;\n}\n.search-top-city-container .header-section-3 .pill *[data-v-d17df2ea] {\n        cursor: pointer;\n        padding: 0;\n        margin: 0;\n}\n.search-top-city-container .pills-description[data-v-d17df2ea] {\n    margin-top: 5px;\n    display: none;\n}\n@media only screen and (min-width: 768px) {\n.search-top-city-container .pills-description[data-v-d17df2ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n}\n.search-top-city-container .pills-description .description-item[data-v-d17df2ea] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      font-size: 12px;\n}\n.search-top-city-container .search-city-relative[data-v-d17df2ea] {\n    position: relative;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.search-top-city-container .search-city-relative i[data-v-d17df2ea] {\n      opacity: 0.6;\n      color: white;\n      font-size: 1.286em;\n}\n.search-top-city-container .search-city-relative .i-1[data-v-d17df2ea] {\n      left: 20px;\n}\n.search-top-city-container .search-city-relative .i-2[data-v-d17df2ea] {\n      left: 65px;\n}\n.search-top-city-container .search-city-relative .i-3[data-v-d17df2ea] {\n      right: 3em;\n}\n.search-top-city-container .search-city-relative .i-4[data-v-d17df2ea] {\n      right: 22px;\n}\n.search-top-city-container-hide[data-v-d17df2ea] {\n  top: -100%;\n}\n.pos-abs[data-v-d17df2ea] {\n  position: absolute;\n}\n.pos-fixed[data-v-d17df2ea] {\n  position: fixed;\n}\n.pos-rel[data-v-d17df2ea] {\n  position: relative;\n}\n@-webkit-keyframes enter {\nfrom {\n    margin-top: -100%;\n}\nto {\n    margin-top: 0;\n}\n}\n@keyframes enter-data-v-d17df2ea {\nfrom {\n    margin-top: -100%;\n}\nto {\n    margin-top: 0;\n}\n}\n.rotate-enter[data-v-d17df2ea] {\n  -webkit-transition: 2s ease-in-out;\n  transition: 2s ease-in-out;\n  opacity: 1;\n  -webkit-animation: 1s enter forwards;\n          animation: 1s enter forwards;\n}\n@-webkit-keyframes leave {\nfrom {\n    margin-top: 0;\n}\nto {\n    margin-top: 50%;\n}\n}\n@keyframes leave-data-v-d17df2ea {\nfrom {\n    margin-top: 0;\n}\nto {\n    margin-top: 50%;\n}\n}\n.rotate-leave[data-v-d17df2ea] {\n  -webkit-transition: 2s ease-in-out;\n  transition: 2s ease-in-out;\n  opacity: 0.1;\n  -webkit-animation: 1s leave infinite;\n          animation: 1s leave infinite;\n}\n.fixed-footer[data-v-d17df2ea] {\n  width: 100%;\n  height: 94px;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.6)));\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));\n  position: fixed;\n  bottom: 0;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.fixed-footer i[data-v-d17df2ea] {\n    z-index: 200;\n    font-size: 1.2em;\n    color: #50e3c2;\n}\n.checkin-scroll[data-v-d17df2ea] {\n  opacity: 0.8;\n  font-size: 0.84em;\n  text-align: left;\n  line-height: 0;\n  letter-spacing: 0;\n  position: absolute;\n  left: 42.66667vw;\n  opacity: 0.8 !important;\n  z-index: 2000;\n}\n.checkin-scroll i[data-v-d17df2ea] {\n    font-size: 1.4em !important;\n}\n.checkin-swipe[data-v-d17df2ea] {\n  opacity: 0.8;\n  font-size: 0.84em;\n  text-align: left;\n  line-height: 0;\n  letter-spacing: 0;\n  position: absolute;\n  left: 26.66667vw;\n  opacity: 0.8 !important;\n  z-index: 2000;\n}\n.checkin-swipe i[data-v-d17df2ea] {\n    font-size: 1.4em !important;\n}\n.share-swipe[data-v-d17df2ea] {\n  opacity: 0.8;\n  font-size: 0.84em;\n  text-align: left;\n  line-height: 0;\n  letter-spacing: 0;\n  position: absolute;\n  left: 48vw;\n  opacity: 0.8 !important;\n  z-index: 2000;\n}\n.share-swipe i[data-v-d17df2ea] {\n    font-size: 1.4em !important;\n}\n.footer-container[data-v-d17df2ea] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  font-family: inherit;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.footer-container .photographer[data-v-d17df2ea] {\n    font-size: 10px;\n    text-transform: capitalize;\n    text-align: left;\n    line-height: 0;\n    letter-spacing: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.footer-container .photographer img[data-v-d17df2ea] {\n      height: 2.8125em;\n      width: 2.8125em;\n      border-radius: 100%;\n      margin-right: 0.4375em;\n}\n.footer-container .photographer .image-details[data-v-d17df2ea] {\n      width: 100%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.footer-container .likes[data-v-d17df2ea] {\n    margin-right: 25px;\n}\n.footer-container .location-and-travel-list[data-v-d17df2ea] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    width: 100%;\n    font-size: 0.75rem;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n.footer-container .spot-new-scroll[data-v-d17df2ea] {\n    margin-right: 20px;\n}\n.footer-container .spot-new-scroll i[data-v-d17df2ea] {\n      margin-left: 5px;\n}\n.footer-container .want-scroll[data-v-d17df2ea] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.footer-container .want-scroll .want-to-go-button-scroll[data-v-d17df2ea] {\n      font-size: 1rem;\n      background-color: #bd10e0;\n      color: #ffffff;\n      font-weight: bold;\n      padding: 10px;\n      border-radius: 6px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      width: 100%;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-family: Montserrat !important;\n}\n.footer-container .want-scroll .want-to-go-button-scroll i[data-v-d17df2ea] {\n        margin-right: 6px;\n}\n.footer-container .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]:hover {\n        background-color: #353535;\n        -webkit-transition: background-color 100ms linear;\n        transition: background-color 100ms linear;\n}\n.footer-container .want-scroll .want-to-go-circle[data-v-d17df2ea] {\n      font-size: 0.65rem;\n      background-color: #bd10e0;\n      color: #ffffff;\n      font-weight: bold;\n      padding: 6px;\n      border-radius: 16px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.footer-container .want-scroll .on-travel-list[data-v-d17df2ea] {\n      background-color: black;\n      color: #f5a623;\n      font-weight: bold;\n      border: 1px solid #f5a623;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      width: 100%;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-size: 1rem;\n      padding: 10px;\n      border-radius: 4px;\n      width: 100%;\n      font-family: Montserrat;\n}\n.footer-container .want-scroll .on-travel-list i[data-v-d17df2ea] {\n        margin-left: 6px;\n}\n.footer-container .want-scroll .on-travel-list[data-v-d17df2ea]:hover {\n        background-color: white;\n        -webkit-transition: background-color 100ms linear;\n        transition: background-color 100ms linear;\n}\n.image-caption-mobile[data-v-d17df2ea] {\n  font-size: 14px;\n  font-family: Montserrat;\n  line-height: 1.2;\n  color: #fff;\n}\n.location-details-mobile[data-v-d17df2ea] {\n  font-size: 12px;\n  font-family: Montserrat;\n  color: #fff;\n}\n.material-icons[data-v-d17df2ea],\n.md-icons[data-v-d17df2ea] {\n  font-family: \"Material Icons\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: \"liga\";\n  -webkit-font-smoothing: antialiased;\n}\n.image-container[data-v-d17df2ea] {\n  position: relative;\n}\n.fullscreen-container[data-v-d17df2ea] {\n  height: 100vh;\n}\n.font-1[data-v-d17df2ea] {\n  font-size: 11px;\n}\n.font-2[data-v-d17df2ea] {\n  font-size: 12px;\n}\n.font-3[data-v-d17df2ea] {\n  font-size: 30px;\n}\n.img-cont[data-v-d17df2ea] {\n  height: 100vh;\n  background-color: #2c2c2c;\n  overflow-x: hidden;\n  -webkit-backface-visibility: hidden;\n  -weblit-overflow-scrolling: hidden;\n}\n.img-cont .relative-img[data-v-d17df2ea] {\n    -weblit-overflow-scrolling: hidden;\n    width: 100%;\n    overflow-y: hidden;\n    position: relative;\n    text-decoration: none;\n}\n.img-cont .relative-img .fullscreen-image[data-v-d17df2ea] {\n      cursor: pointer;\n      width: 100%;\n      border-radius: 12px;\n}\n.img-cont .list-view-image-city-spotType[data-v-d17df2ea] {\n    position: absolute;\n    z-index: 10;\n    bottom: 50px;\n    right: 20px;\n    cursor: pointer;\n    font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    padding: 5px 12px;\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #ffffff;\n}\n@media only screen and (max-width: 768px) {\n.img-cont .list-view-image-city-spotType[data-v-d17df2ea] {\n        right: 10px;\n}\n}\n.img-cont .list-view-image-city-spotType .loc-name[data-v-d17df2ea] {\n      font-size: 11px;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: normal;\n      letter-spacing: normal;\n      opacity: 0.5;\n}\n.img-cont .list-view-image-city-spotType .spot-name[data-v-d17df2ea] {\n      font-size: 12px;\n      font-weight: 600;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: normal;\n      letter-spacing: normal;\n}\n.img-cont .last-image .list-view-image-city-spotType[data-v-d17df2ea] {\n    bottom: 100px;\n}\n.img-cont .last-image .icons-footer-2[data-v-d17df2ea] {\n    margin-bottom: 50px;\n}\n.image-container[data-v-d17df2ea] {\n  height: 100vh;\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.image-container .fullscreen-image[data-v-d17df2ea] {\n    height: 100%;\n    width: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.top-header-icons[data-v-d17df2ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.icons-footer[data-v-d17df2ea] {\n  padding-top: 20px;\n  padding-bottom: 16px;\n  padding-left: 20px;\n  padding-right: 20px;\n  position: fixed;\n  bottom: 0;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(51, 51, 51, 0)), to(#333333));\n  background: linear-gradient(rgba(51, 51, 51, 0), #333333);\n  width: 100%;\n  height: 118px;\n  color: white;\n}\n.icons-footer i[data-v-d17df2ea] {\n    cursor: pointer;\n}\n.icons-footer .footer-container[data-v-d17df2ea] {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.icons-footer .footer-container .distance i[data-v-d17df2ea] {\n      margin-right: 4px;\n}\n.icons-footer .footer-container .likes[data-v-d17df2ea] {\n      margin-right: 25px;\n}\n.icons-footer .footer-container .likes i[data-v-d17df2ea] {\n        margin-right: 5px;\n        font-size: 1.2em !important;\n}\n.icons-footer .footer-container .bottom-menu[data-v-d17df2ea] {\n      position: absolute;\n      left: 84.4vw;\n      opacity: 0.8 !important;\n      z-index: 2000;\n      font-size: 1.2em;\n      height: 55px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      color: #50e3c2;\n}\n.current-page[data-v-d17df2ea] {\n  height: 100vh;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: absolute;\n  font-size: 18em;\n  color: #9e9e9e;\n  z-index: 5;\n}\n.touch[data-v-d17df2ea] {\n  -webkit-overflow-scrolling: touch;\n}\nselect[data-v-d17df2ea] {\n  font-size: 0.857em !important;\n}\n.swipe-arrow-text[data-v-d17df2ea] {\n  font-size: 1.2em;\n  font-weight: 600;\n  color: white;\n  text-shadow: 2px 2px 2px #000000;\n}\n@font-face {\n  font-family: Atma-Medium;\n  font-display: swap;\n  src: url(/static/font/Atma-Medium.ttf);\n}\n.view[data-v-d17df2ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-family: MontSerrat;\n  font-style: normal;\n  font-size: 3.714em;\n  color: white;\n  text-align: left;\n  letter-spacing: 0;\n}\n.viewzzz-main-z[data-v-d17df2ea] {\n  font-family: MontSerrat;\n  font-weight: 600;\n}\n.swipe-container[data-v-d17df2ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.mobile-side-icons[data-v-d17df2ea] {\n  right: 0px;\n}\n.mobile-expand-icon[data-v-d17df2ea] {\n  left: 0px;\n}\n.footer-container-main[data-v-d17df2ea] {\n  position: fixed;\n  bottom: 50px;\n}\n.footer-container-main .blurred-bg[data-v-d17df2ea] {\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n}\n.footer-container-main .footer-container-new[data-v-d17df2ea] {\n    overflow: hidden;\n    position: relative;\n    margin-bottom: 0.571em;\n    border-radius: 1.143em;\n    padding: 5px 16px 5px 20px;\n    opacity: 0.9;\n}\n.footer-container-main .footer-container-new .spot-and-distance[data-v-d17df2ea] {\n      z-index: 8;\n      position: relative;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      font-size: 0.786em;\n      color: white;\n}\n.footer-container-main .footer-container-new .spot-and-distance .distance-new[data-v-d17df2ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n}\n.footer-container-main .footer-container-new .spot-and-distance .distance-new i[data-v-d17df2ea] {\n          margin-top: -0.143em;\n          padding-right: 1em;\n          font-size: 1em;\n}\n.footer-container-main .footer-container-new .spot-and-distance .spot-new[data-v-d17df2ea] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n}\n.footer-container-main .footer-container-new .spot-and-distance .spot-new i[data-v-d17df2ea] {\n          font-size: 1.714em;\n}\n.footer-container-main .footer-container-new .actions[data-v-d17df2ea] {\n      z-index: 8;\n      margin-top: 0.429em;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      font-size: 0.786em;\n      color: white;\n}\n.footer-container-main .footer-container-new .actions .want-to-go-button[data-v-d17df2ea] {\n        z-index: 8;\n        outline: none;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n}\n.footer-container-main .footer-container-new .actions .want-to-go-button i[data-v-d17df2ea] {\n          margin: 5px;\n          background-color: white;\n          border-radius: 100%;\n          z-index: 10 !important;\n          color: #f5a623;\n          font-size: 22px;\n}\n.footer-container-main .footer-container-new .actions .swipe-up-arrow[data-v-d17df2ea] {\n        margin-left: 7px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.footer-container-main .footer-container-new .actions .like-share-fullscreen-container[data-v-d17df2ea] {\n        z-index: 8;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: end;\n            -ms-flex-align: end;\n                align-items: flex-end;\n}\n.footer-container-main .footer-container-new .actions .like-share-fullscreen-container .fullscreen-box[data-v-d17df2ea] {\n          padding: 3px 3px 0px 3px;\n}\n.footer-container-main .footer-container-new .actions .like-share-fullscreen-container i[data-v-d17df2ea] {\n          opacity: 0.6;\n}\n.footer-container-main .footer-container-new .actions .mobile_like[data-v-d17df2ea] {\n        margin: 5px;\n        font-size: 22px;\n}\n.container-switch-modes[data-v-d17df2ea] {\n  top: -50vh;\n  position: absolute;\n  z-index: 4000;\n  height: 18.357em;\n  width: calc(100% - 5%);\n  border-radius: 4px;\n  background: black;\n  border: 1.5px solid #4a4a4a;\n}\n.container[data-v-d17df2ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-overflow-style: none;\n  background-color: #000000;\n  /* IE and Edge */\n  scrollbar-width: none;\n}\n.arrow-container[data-v-d17df2ea] {\n  width: 30px;\n  /* cubic-bezier-easing = sine / mehr Beispiele: https://easings.net/ */\n  -webkit-animation: bounce-data-v-d17df2ea 1600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n          animation: bounce-data-v-d17df2ea 1600ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  cursor: pointer;\n  height: 20px;\n  display: none;\n  position: absolute;\n  bottom: 125px;\n  z-index: 1;\n}\n.arrow-down[data-v-d17df2ea] {\n  height: 6px;\n  background: #bd10e0;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  -webkit-transform-origin: 0% 0%;\n          transform-origin: 0% 0%;\n  border-radius: 5px;\n}\n.arrow-down[data-v-d17df2ea]:after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0;\n  left: 100%;\n  border-radius: 5px;\n  background: #bd10e0;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  -webkit-transform-origin: 0% 100%;\n          transform-origin: 0% 100%;\n}\n@keyframes bounce-data-v-d17df2ea {\n50% {\n    -webkit-transform: translateY(-15px);\n            transform: translateY(-15px);\n}\n}\n.list-view-image-container[data-v-d17df2ea] {\n  margin: 10px;\n  height: auto;\n}\n@media only screen and (min-width: 768px) {\n.list-view-image-container[data-v-d17df2ea] {\n      height: 75vh;\n}\n}\n@media only screen and (max-width: 600px) {\n.list-view-image-container[data-v-d17df2ea] {\n      max-width: 100%;\n}\n}\n@media only screen and (min-width: 601px) and (max-width: 768px) {\n.list-view-image-container[data-v-d17df2ea] {\n      max-width: 100%;\n}\n}\n@media only screen and (min-width: 769px) and (max-width: 1024px) {\n.list-view-image-container[data-v-d17df2ea] {\n      max-width: 100%;\n}\n}\n@media only screen and (min-width: 1025px) and (max-width: 1240px) {\n.list-view-image-container[data-v-d17df2ea] {\n      max-width: 1200px;\n      margin-left: auto;\n      margin-right: auto;\n}\n}\n@media only screen and (min-width: 1240px) {\n.list-view-image-container[data-v-d17df2ea] {\n      max-width: 1440px;\n      margin-left: auto;\n      margin-right: auto;\n}\n}\n.list-view-image-container .container-over-image[data-v-d17df2ea] {\n    position: absolute;\n    z-index: 10;\n    top: 15px;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline;\n    right: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.list-view-image-container .container-over-image .share-scroll[data-v-d17df2ea] {\n      color: #ffffff;\n      -webkit-transform: scaleX(-1);\n              transform: scaleX(-1);\n}\n.list-view-image-container .icon-container[data-v-d17df2ea] {\n    padding: 3px;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.4);\n    height: 30px;\n    width: 30px;\n}\n.list-view-image-container .card-top[data-v-d17df2ea] {\n    display: none;\n    background-color: #353535;\n    padding: 10px;\n    color: #ffffff;\n    margin-bottom: -10px;\n    border-radius: 12px 12px 0px 0px;\n}\n.list-view-image-container .card-top .image-caption[data-v-d17df2ea] {\n      font-size: 14px;\n      font-weight: 600;\n      text-transform: uppercase;\n      margin-bottom: 5px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.list-view-image-container .card-top .location-details[data-v-d17df2ea] {\n      margin-bottom: 0.2rem;\n}\n.list-view-image-container .card-top .location-details .loc-name[data-v-d17df2ea] {\n        font-size: 12px;\n        line-height: 1.2;\n}\n.list-view-image-container .card-top .location-details .spot-name[data-v-d17df2ea] {\n        font-size: 12px;\n        line-height: 1.2;\n}\n.list-view-image-container .icons-footer-2[data-v-d17df2ea] {\n    padding: 10px 0 0 0;\n    background: #000000;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: white;\n    margin-top: -12px;\n    position: relative;\n    border-radius: 0 0 12px 12px;\n}\n.list-view-image-container .icons-footer-2 i[data-v-d17df2ea] {\n      font-size: 20px;\n      cursor: pointer;\n}\n.image-details-mobile[data-v-d17df2ea] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding: 10px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.image-details-mobile .image-caption[data-v-d17df2ea] {\n    font-size: 14px;\n    text-transform: uppercase;\n    margin-bottom: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    text-align: left;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.image-details-mobile .location-details[data-v-d17df2ea] {\n    margin-bottom: 0.2rem;\n}\n.image-details-mobile .location-details .loc-name[data-v-d17df2ea] {\n      font-size: 12px;\n      line-height: 1.2;\n}\n.image-details-mobile .location-details .spot-name[data-v-d17df2ea] {\n      font-size: 12px;\n      line-height: 1.2;\n}\n.image-details-mobile .photographer[data-v-d17df2ea] {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n.list-view-images-container[data-v-d17df2ea] {\n  margin-bottom: 100px;\n  padding: 10px;\n  margin-top: 130px;\n  background-color: #2c2c2c;\n}\n@media only screen and (min-width: 768px) {\n.list-view-images-container[data-v-d17df2ea] {\n      margin-top: 100px;\n      margin-bottom: 100px;\n}\n}\n.image-details-desktop[data-v-d17df2ea] {\n  color: #ffffff;\n  background-color: #000000;\n  width: 30%;\n  border-radius: 0 12px 12px 0;\n  padding: 20px;\n  margin-left: -5px;\n  text-align: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.image-details-desktop .image-caption[data-v-d17df2ea] {\n    font-size: 1.5rem;\n}\n.image-details-desktop .image-location[data-v-d17df2ea] {\n    font-size: 0.75rem;\n}\n.image-details-desktop .details-btn[data-v-d17df2ea] {\n    font-size: 12px;\n    font-weight: 600;\n    text-decoration: none;\n    color: #ffffff;\n    padding: 10px 20px;\n    text-align: center;\n    margin-top: 20px;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    border-radius: 4px;\n    border: 1px solid white;\n}\n.image-details-desktop .details-btn[data-v-d17df2ea]:hover {\n      background-color: #ffffff;\n      color: #000000;\n      -webkit-transition: background-color 100ms linear;\n      transition: background-color 100ms linear;\n}\n.image-details-desktop .footer-container-desktop[data-v-d17df2ea] {\n    position: relative;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-family: inherit;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.image-details-desktop .footer-container-desktop .photograher-likes-share[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      width: 100%;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      margin-bottom: 20px;\n}\n.image-details-desktop .footer-container-desktop .photographer-container[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -ms-flex-pack: distribute;\n          justify-content: space-around;\n}\n.image-details-desktop .footer-container-desktop .photographer-container .photographer[data-v-d17df2ea] {\n        font-size: 0.6875em;\n        text-transform: capitalize;\n        text-align: left;\n        letter-spacing: 0;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.image-details-desktop .footer-container-desktop .photographer-container .photographer img[data-v-d17df2ea] {\n          height: 2.8125em;\n          width: 2.8125em;\n          border-radius: 100%;\n          margin-right: 0.4375em;\n}\n.image-details-desktop .footer-container-desktop .photographer-container .photographer .image-details[data-v-d17df2ea] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n}\n.image-details-desktop .footer-container-desktop .likes[data-v-d17df2ea] {\n      margin-right: 20px;\n      cursor: pointer;\n}\n.image-details-desktop .footer-container-desktop .location-and-travel-list[data-v-d17df2ea] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: flex-end;\n      font-size: 0.75rem;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n      width: 100%;\n}\n.image-details-desktop .footer-container-desktop .spot-new-scroll[data-v-d17df2ea] {\n      margin-right: 20px;\n}\n.image-details-desktop .footer-container-desktop .spot-new-scroll i[data-v-d17df2ea] {\n        margin-left: 5px;\n}\n.image-details-desktop .footer-container-desktop .want-scroll[data-v-d17df2ea] {\n      width: 100%;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll[data-v-d17df2ea] {\n        font-size: 1rem;\n        background-color: #bd10e0;\n        color: #ffffff;\n        font-weight: bold;\n        padding: 10px;\n        border-radius: 4px;\n        width: 100%;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin-top: 10px;\n        font-family: Montserrat;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll i[data-v-d17df2ea] {\n          margin-left: 6px;\n          font-weight: bold;\n          font-size: 1.5rem;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .want-to-go-button-scroll[data-v-d17df2ea]:hover {\n          background-color: #353535;\n          -webkit-transition: background-color 100ms linear;\n          transition: background-color 100ms linear;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list[data-v-d17df2ea] {\n        background-color: black;\n        color: #f5a623;\n        font-weight: bold;\n        border: 1px solid #f5a623;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-top: 10px;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        width: 100%;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        font-size: 1rem;\n        padding: 10px;\n        border-radius: 4px;\n        width: 100%;\n        margin-top: 10px;\n        font-family: Montserrat;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list i[data-v-d17df2ea] {\n          margin-left: 6px;\n}\n.image-details-desktop .footer-container-desktop .want-scroll .on-travel-list[data-v-d17df2ea]:hover {\n          background-color: #ffffff;\n          -webkit-transition: background-color 100ms linear;\n          transition: background-color 100ms linear;\n}\n.pointer[data-v-d17df2ea] {\n  cursor: pointer;\n}\n.check-prices[data-v-d17df2ea] {\n  font-size: 1rem;\n  background-color: #b9b9b9;\n  color: #000000;\n  font-weight: bold;\n  padding: 10px;\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-decoration: none;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-family: Montserrat !important;\n}\n.check-prices i[data-v-d17df2ea] {\n    margin-right: 6px;\n}\n.check-prices[data-v-d17df2ea]:hover {\n    background-color: #353535;\n    color: white;\n    -webkit-transition: background-color 100ms linear;\n    transition: background-color 100ms linear;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("0de31593", content, true, {});

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("fac47256", content, true, {});

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(677);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("3ae72013", content, true, {});

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMzZweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMzZweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xMCAxOGg0di0yaC00djJ6TTMgNnYyaDE4VjZIM3ptMyA3aDEydi0ySDZ2MnoiLz48L3N2Zz4="

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/left-right-hand-swipe-white.2963234.png";

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHJlY3QgaWQ9ImJhY2tncm91bmRyZWN0IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSIwIiB5PSIwIiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiLz4KCjxnIGNsYXNzPSJjdXJyZW50TGF5ZXIiIHN0eWxlPSIiPjx0aXRsZT5MYXllciAxPC90aXRsZT48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNOSAxNWgtMnYtMTFoLTJsMy0zIDMgM2gtMnoiIGlkPSJzdmdfMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsLW9wYWNpdHk9IjEiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(848),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d17df2ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69d8d15c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26f2177b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-modal"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": this.$props.closeSearchModal
    }
  }, [_c('i', {
    staticClass: "material-icons pointer"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Edit your search")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "spotTypeFilterContainer"
  }, [_c('li', {
    staticClass: "spotTypeFilterItem"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.filterResults('all')
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('li', {
    staticClass: "separator"
  }), _vm._v(" "), _c('li', {
    staticClass: "spotTypeFilterItem"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.filterResults('hotel')
      }
    }
  }, [_vm._v("Hotels & Apartments")])]), _vm._v(" "), _c('li', {
    staticClass: "spotTypeFilterItem"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.filterResults('bar')
      }
    }
  }, [_vm._v("Bars & Cafes")])]), _vm._v(" "), _c('li', {
    staticClass: "spotTypeFilterItem"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.filterResults('restaurant')
      }
    }
  }, [_vm._v("Restaurants")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "search-details"
  }, [_c('div', {
    staticClass: "filter-container mt-3"
  }, [_c('div', {
    staticClass: "filter-location"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("location_on")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.search_loc.query_location),
      expression: "$store.state.search_loc.query_location"
    }],
    staticClass: "search-location-dropdown pointer",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.search_loc, "query_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.query_location,
        _vm.goToRoute(_vm.$store.state.search_loc.query_location)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("\n              Where are you going\n            ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "worldwide"
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "barcelona"
    }
  }, [_vm._v("Barcelona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "berlin"
    }
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "copenhagen"
    }
  }, [_vm._v("Copenhagen (København)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "florence"
    }
  }, [_vm._v("Florence (Firenze)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lisbon"
    }
  }, [_vm._v("Lisbon (Lisboa)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "london"
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "angeles"
    }
  }, [_vm._v("Los Angeles")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "madrid"
    }
  }, [_vm._v("Madrid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "milan"
    }
  }, [_vm._v("Milan (Milano)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "newyork"
    }
  }, [_vm._v("New York")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paris"
    }
  }, [_vm._v("Paris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "porto"
    }
  }, [_vm._v("Porto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rome"
    }
  }, [_vm._v("Rome (Roma)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "francisco"
    }
  }, [_vm._v("San Francisco")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(809),
      "width": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('div')])
}]}

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-navigation-container"
  }, [(this.$props.showModeNavigation) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sticky-footer-mobile"
  }, [(_vm.$store.state.common.isModeSwipe != true) ? _c('div', {
    staticClass: "fullscreen",
    on: {
      "click": _vm.navigateToFullScreen
    }
  }, [_c('span', [_vm._v("Full")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (this.$props.isModeSwipe) ? _c('div', {
    staticClass: "fullscreen",
    on: {
      "click": _vm.navigateToListView
    }
  }, [_c('span', [_vm._v("List")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "map-view",
    on: {
      "click": _vm.navigateToMapView
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Map")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sticky-footer-common hidden-md-and-up",
    attrs: {
      "id": "user-footer"
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "footer-icons text-dark text-decoration-none",
    on: {
      "click": _vm.navigateToSaved
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Travel List")])]), _vm._v(" "), _c('span', {
    staticClass: "footer-icons user_account text-dark text-decoration-none",
    on: {
      "click": _vm.navigateToProfile
    }
  }, [(!this.$props.isLoggedIn && this.$props.screenW < 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!this.$props.isLoggedIn && this.$props.screenW > 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": this.$props.user.photoURL
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Me")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out_map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("reorder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-icons text-dark text-decoration-none",
    attrs: {
      "href": "https://www.withaview.co/"
    }
  }, [_c('button', [_c('img', {
    staticClass: "wav-icon-footer",
    attrs: {
      "loading": "lazy",
      "height": "16",
      "src": __webpack_require__(595)
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")])])
}]}

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [(_vm.searchModalOpen) ? _c('searchModal', {
    attrs: {
      "closeSearchModal": _vm.closeSearchModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-top-city-container",
    attrs: {
      "id": "sticky-search-bar"
    }
  }, [(_vm.$store.state.common.isModeSwipe != true) ? _c('div', {
    staticClass: "toolbar-content-container pos-rel"
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('a', {
    staticClass: "go-back-icon-and-fullscreen-mobile",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.filterViewType))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "list-view-text",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('searchContainer')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-section-3"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_c('div', {
    staticClass: "pill-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "0.5px solid #b6b6b6",
      "width": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pill pointer"
  }, [(!_vm.isLoggedIn && this.screenW < 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && this.screenW > 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": this.$store.state.auth.user.photoURL
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pills-description"
  }, [_c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Travel list")]), _vm._v(" "), _c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Profile")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.showScrollArrow && !_vm.$store.state.common.isModeSwipe) ? _c('div', {
    staticClass: "arrow-container"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.isModeSwipe && _vm.filteredImagesArr.length > 0) ? _c('div', [(!_vm.showOnboardings) ? _c('div', [_c('div', {
    staticClass: "footer-container-main mobile-expand-icon",
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "id": "fade-foot"
    }
  }, [_c('div', {
    staticClass: "footer-container-new blurred-bg"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "like-share-fullscreen-container"
  }, [_c('div', {
    staticClass: "fullscreen-box",
    on: {
      "click": function($event) {
        _vm.isSwipeZoom = !_vm.isSwipeZoom
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1.8em"
    },
    style: (_vm.isSwipeZoom ? 'color: rgb(254, 189, 53)' : '')
  }, [_vm._v(_vm._s(_vm.isSwipeZoom ? "zoom_out_map" : "fullscreen_exit"))])])]), _vm._v(" "), _c('div', {
    staticClass: "swipe-up-arrow"
  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.isModeSwipe && _vm.filteredImagesArr.length > 0) ? _c('div', [(!_vm.showOnboardings) ? _c('div', [_c('div', {
    staticClass: "footer-container-main mobile-side-icons",
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "id": "fade-foot"
    }
  }, [_c('div', {
    staticClass: "footer-container-new blurred-bg"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "swipe-up-arrow"
  }), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "material-icons flip-reply-icon mb-3 ml-1",
    on: {
      "click": function($event) {
        return _vm.share(
          _vm.filteredImagesArr[_vm.swipeIndex].id,
          _vm.filteredImagesArr[_vm.swipeIndex].caption === '' ?
          'n' :
          _vm.filteredImagesArr[_vm.swipeIndex].caption
        )
      }
    }
  }, [_vm._v("reply")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "margin-bottom": "23px"
    },
    on: {
      "click": function($event) {
        return _vm.changeCnt()
      }
    }
  }, [_c('div', {
    style: ({
      visibility: ("" + (_vm.filteredImagesArr[_vm.swipeIndex].likes === 0
                        ? 'hidden'
                        : 'visible')),
    })
  }, [_vm._v("\n                  " + _vm._s(_vm.filteredImagesArr[_vm.swipeIndex].likes) + "\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mobile_like",
    style: (_vm.filteredImagesArr[_vm.swipeIndex].isLiked ?
      'color:#ff0000' :
      'color:#ffffff')
  }, [_vm._v(_vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isLiked ?
    "favorite" :
    "favorite_outline"))])]), _vm._v(" "), _c('div', {
    staticClass: "want-to-go-button",
    on: {
      "click": function($event) {
        return _vm.changeCntCheckin()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
    "" :
    ("" + (_vm.filteredImagesArr[_vm.swipeIndex].checkins !== 0
                          ? _vm.filteredImagesArr[_vm.swipeIndex].checkins
                          : ""))) + "\n                "), _c('i', {
    staticClass: "material-icons",
    style: (!_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
      'color: white; backgroundColor:#bd10e0;' :
      '')
  }, [_vm._v(_vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
    "check" :
    "add"))])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-container-main pos-fixed",
    class: ("blur-it-" + (_vm.$store.state.common.swichModesBG)),
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [(_vm.swipeIndex < 2 && _vm.$store.state.common.isModeSwipe) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideOnBoardingOn.indexOf(_vm.swipeIndex) === -1),
      expression: "hideOnBoardingOn.indexOf(swipeIndex) === -1"
    }],
    staticStyle: {
      "position": "fixed",
      "z-index": "10000000",
      "width": "100%",
      "top": "48%"
    },
    attrs: {
      "id": "arrow_down"
    }
  }, [(_vm._isFirstVisit) ? _c('div', [_c('div', {
    staticClass: "swipe-arrow-text",
    domProps: {
      "innerHTML": _vm._s(_vm.swipeArrowText)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa style-icon bounce",
    class: _vm.swipeArrowIcon
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-container pos-rel"
  }, [(_vm.$store.state.common.isModeSwipe) ? _c('div', {
    staticClass: "pos-rel swipe-container"
  }, [_c('v-layout', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function() {},
        right: function() {},
        up: function() {
          _vm.increment();
        },
        down: function() {
          _vm.decrement();
        },
      }),
      expression: "{\n              left: function () {},\n              right: function () {},\n              up: function () {\n                increment();\n              },\n              down: function () {\n                decrement();\n              },\n            }"
    }],
    staticClass: "grey lighten-2",
    staticStyle: {
      "overflow-y": "hidden",
      "height": "100vh"
    },
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": "",
      "id": "layout-swipe"
    },
    on: {
      "touchend": function($event) {
        return _vm.easeOut(1)
      }
    }
  }, [_c('div', {
    style: (_vm.isSwipeZoom ?
      'display: flex; background: black' :
      {
        width: (_vm.screenW + "px"),
        height: (_vm.screenH + "px")
      })
  }, [(
    _vm.getSwipeCount() == 1 ||
    (_vm.getSwipeCount() == 3 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('img', {
    staticClass: "left-right-hand-swipe",
    attrs: {
      "src": __webpack_require__(811)
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 1 ||
    (_vm.getSwipeCount() == 3 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('span', {
    staticClass: "gesture-text-swipe-sides"
  }, [_vm._v("\n                Swipe left and right\n                "), _c('br'), _vm._v("to see the complete image\n              ")]) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 0 ||
    (_vm.getSwipeCount() == 2 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('img', {
    staticClass: "long-up-arrow",
    attrs: {
      "src": __webpack_require__(812)
    },
    on: {
      "click": _vm.increment
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 0 ||
    (_vm.getSwipeCount() == 2 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('span', {
    staticClass: "gesture-text-swipe-up",
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("Swipe up for the next view")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "city-spotType",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/filter',
          query: _vm.$route.query
        })
      }
    }
  }, [_c('label', {
    staticClass: "loc-name"
  }, [_vm._v(_vm._s(_vm.getCity(_vm.filteredImagesArr[_vm.swipeIndex])) + " |")]), _vm._v(" "), _c('label', {
    staticClass: "spot-name",
    style: (_vm.getSpotType(_vm.filteredImagesArr[_vm.swipeIndex]) == 'Spot' ?
      'opacity: 0.7' :
      'opacity: 1')
  }, [_vm._v(_vm._s(_vm.getSpotType(_vm.filteredImagesArr[_vm.swipeIndex])))])]), _vm._v(" "), (_vm.getSwipeCount() == 4 && _vm.$store.state.common.isModeSwipe) ? _c('span', {
    staticClass: "tap-for-details",
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("Tap anywhere for details")]) : _vm._e(), _vm._v(" "), (_vm.filteredImagesArr.length != 0) ? _c('img', {
    style: (_vm.isSwipeZoom ?
      ("width: " + _vm.screenW + "px; object-fit: contain") :
      ("height:" + _vm.screenH + "px")),
    attrs: {
      "src": _vm.fullscreenImage(
        _vm.filteredImagesArr[_vm.swipeIndex].id,
        _vm.filteredImagesArr[_vm.swipeIndex]
      ),
      "id": ("element-" + _vm.swipeIndex),
      "alt": "image"
    },
    on: {
      "click": function($event) {
        return _vm.imageClick($event, _vm.filteredImagesArr[_vm.swipeIndex])
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "opacity": "0.9",
      "z-index": "3",
      "visibility": "hidden",
      "left": "0"
    },
    attrs: {
      "id": ("swipe-ele-black-inc-" + _vm.swipeIndex)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "z-index": "2",
      "visibility": "hidden",
      "left": "0"
    },
    attrs: {
      "id": ("swipe-ele-image-inc-" + _vm.swipeIndex)
    }
  }, [_c('p', {
    staticClass: "current-page"
  }, [_vm._v(_vm._s(_vm.currentPage))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "bottom": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "opacity": "0.4",
      "z-index": "3",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("swipe-ele-black-" + _vm.swipeIndex)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0",
      "bottom": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "z-index": "2",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("swipe-ele-image-" + _vm.swipeIndex)
    }
  }, [_c('p', {
    staticClass: "current-page"
  }, [_vm._v(_vm._s(_vm.currentPage))])])])])], 1) : _c('div', {
    staticClass: "img-cont pos-rel touch",
    attrs: {
      "id": "layout-scroll"
    },
    on: {
      "scroll": _vm.getScrollPos
    }
  }, [(_vm.filteredImagesArr.length != 0) ? _c('div', {
    staticClass: "list-view-images-container"
  }, _vm._l((_vm.filteredImagesArr), function(image, imageIndex) {
    return _c('div', {
      key: imageIndex,
      ref: ("scroll" + imageIndex),
      refInFor: true,
      staticClass: "relative-img touch",
      attrs: {
        "id": ("scroll" + imageIndex)
      },
      on: {
        "mouseover": function($event) {
          return _vm.updateSwipeIndex(imageIndex)
        },
        "touchstart": function($event) {
          return _vm.updateSwipeIndex(imageIndex)
        }
      }
    }, [_c('div', {
      staticClass: "list-view-image-container"
    }, [_c('div', {
      staticClass: "card-top hidden-md-and-up"
    }, [_c('label', {
      staticClass: "image-caption"
    }, [_vm._v(_vm._s(image.caption) + " in ")]), _vm._v(" "), _c('div', {
      staticClass: "location-details"
    }, [_c('label', {
      staticClass: "spot-name pointer",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)))]), _vm._v(" "), _c('label', {
      staticClass: "loc-name pointer"
    }, [_vm._v(_vm._s(_vm.getCity(image)) + ",\n                      " + _vm._s(image.aboutLoc.country))])])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "position": "relative",
        "z-index": "11",
        "height": "100%",
        "overflow": "hidden"
      }
    }, [_c('a', {
      staticStyle: {
        "width": "75%",
        "border-radius": "12px",
        "overflow": "hidden"
      },
      attrs: {
        "href": _vm.currentDomain + '/id/' + image.id + '?inapp=true'
      }
    }, [_c('v-lazy-image', {
      staticClass: "fullscreen-image",
      staticStyle: {
        "width": "100%",
        "min-height": "100%"
      },
      attrs: {
        "src": _vm.listviewImage(image.id, image)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "hidden-sm-and-down image-details-desktop"
    }, [_c('div', [_c('label', {
      staticClass: "image-caption"
    }, [_vm._v(_vm._s(image.caption))]), _vm._v(" "), _c('div', {
      staticClass: "image-location"
    }, [_c('label', {
      staticClass: "spot-name",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)) + " in\n                        ")]), _vm._v(" "), _c('label', {
      staticClass: "loc-name"
    }, [_vm._v(_vm._s(_vm.getCity(image)) + ",\n                          " + _vm._s(image.aboutLoc.country))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "details-btn p-3 pointer",
      attrs: {
        "href": _vm.currentDomain + '/id/' + image.id + '?inapp=true',
        "target": _vm.target
      }
    }, [_c('label', {
      staticClass: "pointer"
    }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
      staticClass: "footer-container-desktop"
    }, [_c('div', {
      staticClass: "photograher-likes-share"
    }, [_c('div', {
      staticClass: "photographer-container"
    }, [_c('div', {
      staticClass: "photographer",
      style: (image.uploader === 'admin' ?
        {
          color: '#b9b9b9'
        } :
        {
          cursor: 'pointer'
        }),
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ? _vm.saveInLs() : '';
          image.uploader !== 'admin' ?
            _vm.$router.push({
              path: '/profile',
              query: {
                uploader: image.uploader,
                profile_id: image.mediaSourceInformation
                  .photoGrapherId,
                selected_tab: 'checkins',
              },
            }) :
            '';
        }
      }
    }, [(image.uploader !== 'admin') ? _c('img', {
      attrs: {
        "src": image.mediaSourceInformation.photoGrapherPic,
        "alt": "profile-photo"
      },
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ?
            _vm.$router.push(
              ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
            ) :
            ''
        }
      }
    }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.cropUsername(
      image.mediaSourceInformation.photoGrapherName
    )) + "\n                            ©\n                          ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "likes",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "height": "fit-content"
      }
    }, [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "font-size": "1.403em",
        "margin-left": "5px"
      },
      style: ({
        color: ("" + (image.isLiked ? '#ff0000' : '#ffffff')),
        opacity: ("" + (image.isLiked ? '1' : '0.5')),
      }),
      on: {
        "click": function($event) {
          return _vm.changeCnt()
        }
      }
    }, [_vm._v(_vm._s(image.isLiked ?
      "favorite" :
      "favorite_outline"))])]), _vm._v(" "), _c('i', {
      staticClass: "\n                              white--text\n                              material-icons\n                              pointer\n                              flip-reply-icon\n                            ",
      on: {
        "click": function($event) {
          return _vm.share(
            image.id,
            image.caption === '' ? 'n' : image.caption
          )
        }
      }
    }, [_vm._v("reply")])])]), _vm._v(" "), _c('div', {
      staticClass: "location-and-travel-list"
    }, [_c('div', {
      staticClass: "want-scroll"
    }, [(image.propertyLink && _vm.tab === 'hotel') ? _c('a', {
      staticClass: "check-prices mr-1",
      attrs: {
        "href": image.propertyLink,
        "target": "_blank"
      }
    }, [_vm._v("\n                            Check Price\n                          ")]) : _vm._e(), _vm._v(" "), _c('button', {
      class: image.isCheckedin ?
        'on-travel-list' :
        'want-to-go-button-scroll',
      on: {
        "click": function($event) {
          return _vm.changeCntCheckin()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons mr-2",
      style: (!image.isCheckedin ?
        'color: white;font-size: 1.5rem;' :
        'font-size: 1.8em;color: #febd35')
    }, [_vm._v(_vm._s(image.isCheckedin ? "check" : "add"))]), _vm._v("\n                            " + _vm._s(image.isCheckedin ?
      "On travel list" :
      "Save to travel list") + "\n                          ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "container-over-image hidden-md-and-up"
    }, [_c('div', {
      staticClass: "likes",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "height": "fit-content"
      }
    }, [_c('span', {
      staticClass: "icon-container mr-3"
    }, [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "margin-top": "1px"
      },
      style: ({
        color: ("" + (image.isLiked ? '#ff0000' : '#ffffff')),
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeCnt()
        }
      }
    }, [_vm._v(_vm._s(image.isLiked ? "favorite" : "favorite_outline"))])])]), _vm._v(" "), _c('span', {
      staticClass: "icon-container"
    }, [_c('img', {
      attrs: {
        "src": "static/img/ic-reply.svg",
        "height": "24px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.share(
            image.id,
            image.caption === '' ? 'n' : image.caption
          )
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "icons-footer-2 hidden-md-and-up"
    }, [_c('div', {
      staticClass: "footer-container"
    }, [_c('div', {
      staticClass: "location-and-travel-list"
    }, [_c('div', {
      staticClass: "image-details-mobile"
    }, [_c('label', {
      staticClass: "image-caption",
      on: {
        "click": function($event) {
          return _vm.imageDet(image, imageIndex)
        }
      }
    }, [_vm._v(_vm._s(image.caption))]), _vm._v(" "), _c('div', {
      staticClass: "location-details",
      on: {
        "click": function($event) {
          return _vm.imageDet(image, imageIndex)
        }
      }
    }, [_c('label', {
      staticClass: "spot-name pointer",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)))]), _vm._v(" "), _c('label', {
      staticClass: "loc-name pointer"
    }, [_vm._v("in " + _vm._s(_vm.getCity(image)) + ",\n                            " + _vm._s(image.aboutLoc.country))])]), _vm._v(" "), _c('div', {
      staticClass: "photographer",
      style: (image.uploader === 'admin' ?
        {
          color: '#b9b9b9'
        } :
        {
          cursor: 'pointer'
        }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          image.uploader !== 'admin' ? _vm.saveInLs() : '';
          image.uploader !== 'admin' ?
            _vm.$router.push({
              path: '/profile',
              query: {
                uploader: image.uploader,
                profile_id: image.mediaSourceInformation
                  .photoGrapherId,
                selected_tab: 'checkins',
              },
            }) :
            '';
        }
      }
    }, [(
      image.mediaSourceInformation.photoGrapherPic !==
      'http://cdn.onlinewebfonts.com/svg/img_191958.png'
    ) ? _c('img', {
      attrs: {
        "src": image.mediaSourceInformation.photoGrapherPic,
        "alt": "profile-photo"
      },
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ?
            _vm.$router.push(
              ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
            ) :
            ''
        }
      }
    }) : _vm._e(), _vm._v("\n                          " + _vm._s(_vm.cropUsername(
      image.mediaSourceInformation.photoGrapherName
    )) + "\n                          ©\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "want-scroll"
    }, [(image.propertyLink && _vm.tab === 'hotel') ? _c('a', {
      staticClass: "check-prices mr-1",
      attrs: {
        "href": image.propertyLink,
        "target": "_blank"
      }
    }, [_vm._v("\n                          Check Price\n                        ")]) : _vm._e(), _vm._v(" "), _c('button', {
      class: image.isCheckedin ?
        'on-travel-list' :
        'want-to-go-button-scroll',
      on: {
        "click": function($event) {
          return _vm.changeCntCheckin()
        }
      }
    }, [(!image.propertyLink) ? _c('i', {
      staticClass: "material-icons",
      style: (!image.isCheckedin ?
        'color: white;font-size: 1.8em;' :
        'font-size: 1.8em;color: #febd35')
    }, [_vm._v(_vm._s(image.isCheckedin ? "check" : "add"))]) : _vm._e(), _vm._v("\n                          " + _vm._s(image.isCheckedin ?
      "On travel list" :
      "Save to travel list") + "\n                        ")])])])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (
    _vm.filteredImagesArr.length == 0 &&
    this.selectedCity !== 'worldwide' &&
    this.selectedCity !== undefined
  ) ? _c('div', {
    staticClass: "no-photos"
  }, [_c('label', [_vm._v("No Photos Available for the current location filter.")])]) : _vm._e()])])])]), _vm._v(" "), _c('bottom-navigation', {
    attrs: {
      "localStorageName": "homePageImages",
      "screenH": _vm.screenH,
      "screenW": _vm.screenW,
      "view": "list",
      "maxPhotos": _vm.filteredImagesArr.length,
      "swipeIndex": _vm.swipeIndex,
      "isModeSwipe": this.$store.state.common.isModeSwipe,
      "lastSelectedQuery": this.$route.query.loc,
      "filteredImagesArr": _vm.filteredImagesArr,
      "isLoggedIn": this.$store.state.auth.isLoggedIn,
      "user": this.$store.state.auth.user,
      "setSwipeIndex": _vm.setSwipeIndex,
      "showModeNavigation": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "alt": "logo",
      "height": "30px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-decoration-none",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('img', {
    staticClass: "hidden-md-and-up mt-2",
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "height": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pill pointer",
    staticStyle: {
      "color": "#b6b6b6",
      "flex-grow": "1"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")])])
}]}

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keep-alive', [_c('hello')], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/4.c10f377ee2a762632d28.js